(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digital-journal-plus"] && !Shopify.designMode) return;
  try {
    
function tjpChoosePath(path) {
  const createPath = document.getElementById('tjpCreatePath');
  const sellPath = document.getElementById('tjpSellPath');
  const createWorkflow = document.getElementById('tjpCreateWorkflow');
  const sellWorkflow = document.getElementById('tjpSellWorkflow');

  createPath.classList.toggle('active', path === 'create');
  sellPath.classList.toggle('active', path === 'sell');
  createWorkflow.classList.toggle('active', path === 'create');
  sellWorkflow.classList.toggle('active', path === 'sell');

  setTimeout(function() {
    const target = path === 'create' ? createWorkflow : sellWorkflow;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 50);
}

function tjpHandleCustom(select) {
  const wrap = document.getElementById(select.id + 'CustomWrap');
  if (!wrap) return;
  wrap.classList.toggle('show', select.value === 'USE_MY_OWN');
}

function tjpHandleCanvasSize() {
  const select = document.getElementById('tjpCanvasSize');
  const wrap = document.getElementById('tjpCanvasSizeCustomWrap');
  const hint = document.getElementById('tjpCanvasSizeHint');

  wrap.classList.toggle('show', select.value === 'CUSTOM_SIZE');

  if (select.value === 'CUSTOM_SIZE') {
    hint.textContent = 'Enter the exact custom dimensions you plan to use in Canva.';
  } else {
    hint.textContent = 'Canva match: ' + select.value + '. Use this exact size when creating the Canva design.';
  }
}

function tjpHandlePageCount() {
  const select = document.getElementById('tjpPageCount');
  document.getElementById('tjpPageCountCustomWrap').classList.toggle('show', select.value === 'CUSTOM_COUNT');
}

function tjpHandleRepeatPage() {
  const select = document.getElementById('tjpRepeatPage');
  document.getElementById('tjpRepeatPageCustomWrap').classList.toggle('show', select.value === 'CUSTOM_REPEAT');
}

function tjpHandleRepeatCount() {
  const select = document.getElementById('tjpRepeatCount');
  document.getElementById('tjpRepeatCountCustomWrap').classList.toggle('show', select.value === 'CUSTOM_REPEAT_COUNT');
}

function tjpGetSelectedValue(selectId) {
  const select = document.getElementById(selectId);
  if (!select) return '';

  if (select.value === 'USE_MY_OWN') {
    const custom = document.getElementById(selectId + 'Custom');
    return custom && custom.value.trim() ? custom.value.trim() : 'Custom direction';
  }

  return select.value;
}

function tjpGetCanvasSize() {
  const select = document.getElementById('tjpCanvasSize');
  if (select.value === 'CUSTOM_SIZE') {
    const custom = document.getElementById('tjpCanvasSizeCustom').value.trim();
    return custom || 'Custom size not entered';
  }
  return select.value;
}

function tjpGetPageCount() {
  const select = document.getElementById('tjpPageCount');
  if (select.value === 'CUSTOM_COUNT') {
    const custom = parseInt(document.getElementById('tjpPageCountCustom').value, 10);
    return custom > 0 ? custom : 30;
  }
  return parseInt(select.value, 10) || 30;
}

function tjpGetRepeatPage() {
  const select = document.getElementById('tjpRepeatPage');
  if (select.value === 'CUSTOM_REPEAT') {
    const custom = document.getElementById('tjpRepeatPageCustom').value.trim();
    return custom || 'Custom repeating page';
  }
  return select.value;
}

function tjpGetRepeatCount() {
  const select = document.getElementById('tjpRepeatCount');
  if (select.value === 'CUSTOM_REPEAT_COUNT') {
    const custom = parseInt(document.getElementById('tjpRepeatCountCustom').value, 10);
    return custom >= 0 ? custom : 0;
  }
  return parseInt(select.value, 10) || 0;
}

function tjpGetCheckedValues(selector) {
  const checks = document.querySelectorAll(selector + ' input:checked');
  return Array.from(checks).map(function(check) { return check.value; });
}

function tjpGetFileName(inputId) {
  const input = document.getElementById(inputId);
  return input && input.files && input.files.length ? input.files[0].name : '';
}

function tjpInspectImage(input, metaId, qualityId) {
  const meta = document.getElementById(metaId);
  const quality = document.getElementById(qualityId);

  if (!input.files || !input.files.length) {
    meta.textContent = 'No image selected';
    quality.className = 'tjp-quality hidden';
    quality.textContent = '';
    return;
  }

  const file = input.files[0];
  const objectUrl = URL.createObjectURL(file);
  const image = new Image();

  image.onload = function() {
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    const shortEdge = Math.min(width, height);
    const megapixels = (width * height) / 1000000;
    const fileMb = file.size / (1024 * 1024);

    meta.textContent = file.name + ' | ' + width + ' x ' + height + ' px | ' + fileMb.toFixed(1) + ' MB';

    const strongEnough = shortEdge >= 1800 || megapixels >= 4;
    quality.className = 'tjp-quality ' + (strongEnough ? 'good' : 'warn');
    quality.textContent = strongEnough
      ? 'Image quality: Good for most journal layouts'
      : 'Image quality: May look soft if enlarged. A larger file is recommended.';

    URL.revokeObjectURL(objectUrl);
  };

  image.onerror = function() {
    meta.textContent = file.name;
    quality.className = 'tjp-quality warn';
    quality.textContent = 'Jen could not read the image dimensions. Check the file before using it.';
    URL.revokeObjectURL(objectUrl);
  };

  image.src = objectUrl;
}

function tjpGenerateBlueprint() {
  const productType = tjpGetSelectedValue('tjpProductType');
  const formatType = document.getElementById('tjpFormatType').value;
  const canvasSize = tjpGetCanvasSize();
  const pageCount = tjpGetPageCount();
  const sections = tjpGetCheckedValues('#tjpPageSections');
  const repeatPage = tjpGetRepeatPage();
  const repeatCount = repeatPage === 'NONE' ? 0 : tjpGetRepeatCount();
  const extraPages = document.getElementById('tjpExtraPages').value.trim();

  const basePages = 2 + sections.length;
  const usedPages = basePages + repeatCount;
  const remainingPages = Math.max(pageCount - usedPages, 0);

  let blueprint = `PLUS PRODUCT BLUEPRINT

PRODUCT:
${productType}

FINAL FORMAT:
${formatType}

CANVA TEMPLATE SIZE:
${canvasSize}

TOTAL PAGE TARGET:
${pageCount} pages

SUGGESTED PAGE MAP:
Page 1: Cover
Page 2: Welcome or How to Use This Journal
`;

  let pageNumber = 3;

  sections.forEach(function(section) {
    blueprint += `Page ${pageNumber}: ${section}\n`;
    pageNumber += 1;
  });

  if (repeatPage !== 'NONE' && repeatCount > 0) {
    blueprint += `\nREPEATING PAGE SYSTEM:\n`;
    blueprint += `${repeatPage}: repeat ${repeatCount} times using the exact same layout and design system.\n`;
  }

  if (extraPages) {
    blueprint += `\nADDITIONAL PAGE IDEAS:\n${extraPages}\n`;
  }

  blueprint += `\nPAGE COUNT CHECK:\n`;
  blueprint += `Core planned pages: ${basePages}\n`;
  blueprint += `Repeating pages: ${repeatCount}\n`;
  blueprint += `Pages remaining for dividers, notes, bonus pages, resources, or additional content: ${remainingPages}\n`;

  if (usedPages > pageCount) {
    blueprint += `\nIMPORTANT: The current page plan is larger than the selected ${pageCount}-page target. Reduce the repeat count or remove sections before finalizing the Canva prompt.\n`;
  }

  blueprint += `\nBLUEPRINT RULE:\n`;
  blueprint += `Keep the journal organized, consistent, useful, and realistic for the selected page count. Repeating pages should remain visually identical unless the user specifically asks for variations.`;

  document.getElementById('tjpBlueprintOutput').value = blueprint;
  document.getElementById('tjpBlueprintWrap').classList.add('show');
  document.getElementById('tjpMetaSize').textContent = canvasSize;
  document.getElementById('tjpMetaPages').textContent = pageCount + ' pages';
  document.getElementById('tjpMetaFormat').textContent = formatType;
  document.getElementById('tjpMetaRepeat').textContent = repeatPage === 'NONE' ? 'None' : repeatPage + ' x ' + repeatCount;

  tjpShowStatus('tjpBlueprintStatus', usedPages > pageCount ? 'error' : 'success',
    usedPages > pageCount
      ? 'Your blueprint is larger than the selected page count. Edit the blueprint or adjust the repeat count before creating the Canva prompt.'
      : 'Blueprint ready. Review and edit it before moving to the Canva prompt.');

  document.getElementById('tjpBlueprintWrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function tjpGenerateCanvaPrompt() {
  const productType = tjpGetSelectedValue('tjpProductType');
  const formatType = document.getElementById('tjpFormatType').value;
  const canvasSize = tjpGetCanvasSize();
  const pageCount = tjpGetPageCount();
  const styleType = tjpGetSelectedValue('tjpStyleType');
  const colorPalette = tjpGetSelectedValue('tjpColorPalette');
  const layoutMode = document.getElementById('tjpLayoutMode').value;
  const printMode = document.getElementById('tjpPrintMode').value;
  const designLocks = tjpGetCheckedValues('#tjpDesignLocks');
  const extraDirection = document.getElementById('tjpExtraDirection').value.trim();
  const backgroundFile = tjpGetFileName('tjpBackgroundFile');
  const artworkFile = tjpGetFileName('tjpArtworkFile');
  const blueprint = document.getElementById('tjpBlueprintOutput').value.trim();

  if (!blueprint) {
    tjpGenerateBlueprint();
  }

  const finalBlueprint = document.getElementById('tjpBlueprintOutput').value.trim();

  const backgroundInstructions = backgroundFile
    ? `BACKGROUND FILE ATTACHED: ${backgroundFile}\nUse the attached background as locked source artwork. Preserve its visual identity.`
    : 'No custom background is attached. Create the background using the selected style, palette, and premium layout mode.';

  const artworkInstructions = artworkFile
    ? `ARTWORK FILE ATTACHED: ${artworkFile}\nUse the attached artwork exactly as the source wherever appropriate.`
    : 'No separate custom artwork is attached.';

  const lockText = designLocks.length
    ? designLocks.join('\n- ')
    : 'Keep the entire journal visually consistent.';

  const prompt = `Create a premium, finished ${productType} in Canva.

PLUS PRODUCT SETUP

PRODUCT:
${productType}

FINAL FORMAT:
${formatType}

EXACT CANVA TEMPLATE SIZE:
${canvasSize}

SIZE LOCK:
Create the design at exactly ${canvasSize}.
Do not change the canvas size.
Do not change the aspect ratio.
The student will open this exact size in Canva and the design should match it.

TOTAL PAGE TARGET:
${pageCount} pages

PREMIUM LAYOUT MODE:
${layoutMode}

STYLE:
${styleType}

COLOR PALETTE:
${colorPalette}

PRINT AND EXPORT SETUP:
${printMode}

PRODUCT BLUEPRINT:
${finalBlueprint}

DESIGN SYSTEM LOCK:
- ${lockText}

${backgroundInstructions}

${artworkInstructions}

USER DIRECTION:
${extraDirection || 'Create a clean, premium, commercially strong journal with intentional spacing, polished typography, useful writing areas, and a consistent design system from cover through every interior page.'}

IMPORTANT IMAGE QUALITY LOCK:
If any user-supplied image, background, pattern, logo, illustration, photo, or artwork is attached, treat that file as locked original artwork.
- Do not redraw it.
- Do not regenerate it.
- Do not reinterpret it.
- Do not blur it.
- Do not stretch it.
- Do not distort its proportions.
- Do not change typography contained inside it.
- Do not change important colors or visual details.
- Do not replace it with a similar generated version.
- Maintain the original aspect ratio.
- If it does not match the selected canvas shape, crop, contain, tile, repeat, or add intentional space instead of stretching it.
- If the source image is too small to enlarge cleanly, keep it smaller or tile it rather than making it blurry.

PREMIUM DESIGN REQUIREMENTS:
Create a finished journal design, not a rough concept or plain worksheet.
Use strong typography hierarchy.
Keep margins, spacing, and alignment intentional.
Keep repeating pages visually identical unless the blueprint says otherwise.
Keep the cover and interior pages connected by one clear design system.
Use enough white space for the selected product style.
Avoid decorative clutter.
Make the product look polished enough to sell as a premium digital product.
Keep editable Canva elements modular and beginner friendly.
Do not use copyrighted characters, brand logos, or trademarked artwork unless the user supplied them and has permission to use them.

OUTPUT:
Build the journal according to the blueprint and selected Canva size.
Keep the design consistent from cover through the final page.`;

  document.getElementById('tjpCanvaOutput').value = prompt;
  document.getElementById('tjpCanvaOutputWrap').classList.add('show');
  tjpShowStatus('tjpCanvaStatus', 'success', 'Your Plus Canva AI prompt is ready. Copy it, open Canva AI, use the exact selected canvas size, attach your artwork, and paste the prompt.');
  document.getElementById('tjpCanvaOutputWrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

async function tjpCopyCanvaPrompt() {
  const output = document.getElementById('tjpCanvaOutput');
  if (!output.value.trim()) tjpGenerateCanvaPrompt();
  await tjpCopyText(output.value, output);
  tjpShowStatus('tjpCanvaStatus', 'success', 'Prompt copied. Open Canva AI and use the exact canvas size selected above.');
}

function tjpOpenCanvaAI() {
  window.open('https://www.canva.com/ai/', '_blank', 'noopener');
}

function tjpGenerateSellingKit() {
  const name = document.getElementById('tjpSellName').value.trim();
  const type = tjpGetSelectedValue('tjpSellType');
  const audience = document.getElementById('tjpSellAudience').value.trim();
  const marketplace = document.getElementById('tjpMarketplace').value;
  const contents = document.getElementById('tjpSellContents').value.trim();
  const result = document.getElementById('tjpSellResult').value.trim();
  const features = tjpGetCheckedValues('#tjpSellFeatures');

  if (!name) {
    tjpShowStatus('tjpSellStatus', 'error', 'Add the journal name first.');
    document.getElementById('tjpSellName').focus();
    return;
  }

  const requested = features.length
    ? features.join(', ')
    : 'product title, product description, pricing direction, keywords, mockup image plan, benefit bullets, launch captions, offer positioning, and bundle ideas';

  const prompt = `Act as a premium digital product marketing strategist and ecommerce copywriter.

I already have a finished digital journal. Help me turn it into a polished, ready-to-sell offer.

PRODUCT NAME:
${name}

PRODUCT TYPE:
${type}

TARGET CUSTOMER:
${audience || 'Define the strongest likely target customer based on the product.'}

MARKETPLACE:
${marketplace}

WHAT IS INSIDE:
${contents || 'Use the product type and title to infer a practical journal structure. Do not invent exaggerated features.'}

CUSTOMER RESULT:
${result || 'Define the clearest practical outcome this journal can help the customer work toward.'}

CREATE THESE ASSETS:
${requested}

PLUS WRITING DIRECTION:
- Make the copy feel premium, useful, commercially strong, and human.
- Avoid hype, fake urgency, and unrealistic promises.
- Focus on the customer's problem, desired outcome, and how the journal helps.
- Do not use long dashes.
- Do not use generic AI language.
- Make the listing easy to scan on mobile.
- If writing for Etsy, use search-friendly phrases naturally.
- If writing for Shopify, prioritize conversion, clarity, benefits, and clean formatting.
- Give practical pricing direction based on product depth, usefulness, and perceived value.
- For mockups, give a clear image-by-image plan that can be recreated in Canva.
- For launch captions, create 3 angles: problem-aware, transformation-focused, and direct offer.
- For offer positioning, give one clear headline angle and one clear promise angle.
- For bundle ideas, suggest realistic companion products or upsells that naturally fit this journal.

OUTPUT FORMAT:
Organize the answer into clear sections.
Start with the strongest recommended product title.
Then provide the listing copy.
Then pricing direction.
Then keywords or tags.
Then the mockup image plan.
Then the offer positioning.
Then bundle or upsell ideas.
Finish with the launch captions.

Make the finished offer feel boutique, intentional, and worth paying for.`;

  document.getElementById('tjpSellOutput').value = prompt;
  document.getElementById('tjpSellOutputWrap').classList.add('show');
  tjpShowStatus('tjpSellStatus', 'success', 'Your Plus Selling Kit is ready to copy.');
  document.getElementById('tjpSellOutputWrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

async function tjpCopySellingKit() {
  const output = document.getElementById('tjpSellOutput');
  if (!output.value.trim()) tjpGenerateSellingKit();
  if (!output.value.trim()) return;
  await tjpCopyText(output.value, output);
  tjpShowStatus('tjpSellStatus', 'success', 'Plus Selling Kit copied.');
}

async function tjpCopyText(text, fallbackElement) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    fallbackElement.removeAttribute('readonly');
    fallbackElement.select();
    fallbackElement.setSelectionRange(0, fallbackElement.value.length);
    document.execCommand('copy');
    fallbackElement.setAttribute('readonly', 'readonly');
  }
}

function tjpShowStatus(id, type, message) {
  const status = document.getElementById(id);
  status.className = 'tjp-status show ' + type;
  status.textContent = message;
}

function tjpResetAll() {
  if (!confirm('Start over and clear everything in Try Jen Digital Journal Plus?')) return;

  document.getElementById('tjpCreatePath').classList.remove('active');
  document.getElementById('tjpSellPath').classList.remove('active');
  document.getElementById('tjpCreateWorkflow').classList.remove('active');
  document.getElementById('tjpSellWorkflow').classList.remove('active');

  [
    'tjpProductType','tjpFormatType','tjpCanvasSize','tjpPageCount',
    'tjpRepeatPage','tjpRepeatCount','tjpLayoutMode','tjpPrintMode',
    'tjpStyleType','tjpColorPalette','tjpSellType','tjpMarketplace'
  ].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.selectedIndex = 0;
  });

  [
    'tjpProductTypeCustom','tjpCanvasSizeCustom','tjpPageCountCustom',
    'tjpRepeatPageCustom','tjpRepeatCountCustom','tjpExtraPages',
    'tjpBlueprintOutput','tjpStyleTypeCustom','tjpColorPaletteCustom',
    'tjpExtraDirection','tjpCanvaOutput','tjpSellName','tjpSellTypeCustom',
    'tjpSellAudience','tjpSellContents','tjpSellResult','tjpSellOutput'
  ].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.value = '';
  });

  document.querySelectorAll('.tjp-custom-field').forEach(function(el) {
    el.classList.remove('show');
  });

  document.querySelectorAll('#tjpPageSections input').forEach(function(check, index) {
    check.checked = index === 0;
  });

  document.querySelectorAll('#tjpDesignLocks input').forEach(function(check) {
    check.checked = true;
  });

  document.querySelectorAll('#tjpSellFeatures input').forEach(function(check) {
    check.checked = true;
  });

  ['tjpBackgroundFile','tjpArtworkFile'].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.value = '';
  });

  document.getElementById('tjpBackgroundMeta').textContent = 'No background selected';
  document.getElementById('tjpArtworkMeta').textContent = 'No artwork selected';
  document.getElementById('tjpBackgroundQuality').className = 'tjp-quality hidden';
  document.getElementById('tjpArtworkQuality').className = 'tjp-quality hidden';
  document.getElementById('tjpBlueprintWrap').classList.remove('show');
  document.getElementById('tjpCanvaOutputWrap').classList.remove('show');
  document.getElementById('tjpSellOutputWrap').classList.remove('show');

  document.getElementById('tjpMetaSize').textContent = 'Not set';
  document.getElementById('tjpMetaPages').textContent = 'Not set';
  document.getElementById('tjpMetaFormat').textContent = 'Not set';
  document.getElementById('tjpMetaRepeat').textContent = 'None';

  document.querySelectorAll('.tjp-status').forEach(function(status) {
    status.className = 'tjp-status';
    status.textContent = '';
  });

  tjpHandleCanvasSize();
  document.getElementById('tjpJournalApp').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

window.tjpChoosePath = tjpChoosePath;
window.tjpHandleCustom = tjpHandleCustom;
window.tjpHandleCanvasSize = tjpHandleCanvasSize;
window.tjpHandlePageCount = tjpHandlePageCount;
window.tjpHandleRepeatPage = tjpHandleRepeatPage;
window.tjpHandleRepeatCount = tjpHandleRepeatCount;
window.tjpInspectImage = tjpInspectImage;
window.tjpGenerateBlueprint = tjpGenerateBlueprint;
window.tjpGenerateCanvaPrompt = tjpGenerateCanvaPrompt;
window.tjpCopyCanvaPrompt = tjpCopyCanvaPrompt;
window.tjpOpenCanvaAI = tjpOpenCanvaAI;
window.tjpGenerateSellingKit = tjpGenerateSellingKit;
window.tjpCopySellingKit = tjpCopySellingKit;
window.tjpResetAll = tjpResetAll;

document.addEventListener('DOMContentLoaded', function() {
  tjpHandleCanvasSize();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-jen-digital-journalV2"] && !Shopify.designMode) return;
  try {
    
function tjChoosePath(path) {
  const createPath = document.getElementById('tjCreatePath');
  const sellPath = document.getElementById('tjSellPath');
  const createWorkflow = document.getElementById('tjCreateWorkflow');
  const sellWorkflow = document.getElementById('tjSellWorkflow');

  createPath.classList.toggle('active', path === 'create');
  sellPath.classList.toggle('active', path === 'sell');
  createWorkflow.classList.toggle('active', path === 'create');
  sellWorkflow.classList.toggle('active', path === 'sell');

  setTimeout(function() {
    const target = path === 'create' ? createWorkflow : sellWorkflow;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 50);
}

function tjHandleCustom(select) {
  const wrap = document.getElementById(select.id + 'CustomWrap');
  if (!wrap) return;
  wrap.classList.toggle('show', select.value === 'USE_MY_OWN');
}

function tjGetSelectedValue(selectId) {
  const select = document.getElementById(selectId);
  if (!select) return '';

  if (select.value === 'USE_MY_OWN') {
    const custom = document.getElementById(selectId + 'Custom');
    return custom && custom.value.trim() ? custom.value.trim() : 'Custom direction';
  }

  return select.value;
}

function tjGetCheckedCreateSections() {
  const checks = document.querySelectorAll('#tjCreateWorkflow .tj-checkbox-grid input:checked');
  return Array.from(checks).map(function(check) { return check.value; });
}

function tjGetSellFeatures() {
  const checks = document.querySelectorAll('#tjSellFeatures input:checked');
  return Array.from(checks).map(function(check) { return check.value; });
}

function tjGetFileName(inputId) {
  const input = document.getElementById(inputId);
  return input && input.files && input.files.length ? input.files[0].name : '';
}

function tjInspectImage(input, metaId, qualityId) {
  const meta = document.getElementById(metaId);
  const quality = document.getElementById(qualityId);

  if (!input.files || !input.files.length) {
    meta.textContent = 'No image selected';
    quality.className = 'tj-quality hidden';
    quality.textContent = '';
    return;
  }

  const file = input.files[0];
  const objectUrl = URL.createObjectURL(file);
  const image = new Image();

  image.onload = function() {
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    const shortEdge = Math.min(width, height);
    const megapixels = (width * height) / 1000000;
    const fileMb = file.size / (1024 * 1024);

    meta.textContent = file.name + ' | ' + width + ' x ' + height + ' px | ' + fileMb.toFixed(1) + ' MB';

    const strongEnough = shortEdge >= 1800 || megapixels >= 4;
    quality.className = 'tj-quality ' + (strongEnough ? 'good' : 'warn');
    quality.textContent = strongEnough
      ? 'Image quality: Good for most journal layouts'
      : 'Image quality: May look soft if enlarged. A larger file is recommended.';

    URL.revokeObjectURL(objectUrl);
  };

  image.onerror = function() {
    meta.textContent = file.name;
    quality.className = 'tj-quality warn';
    quality.textContent = 'Jen could not read the image dimensions. Check the file before using it.';
    URL.revokeObjectURL(objectUrl);
  };

  image.src = objectUrl;
}

function tjGenerateCanvaPrompt() {
  const productType = tjGetSelectedValue('tjProductType');
  const styleType = tjGetSelectedValue('tjStyleType');
  const colorPalette = tjGetSelectedValue('tjColorPalette');
  const formatType = document.getElementById('tjFormatType').value;
  const extraDirection = document.getElementById('tjExtraDirection').value.trim();
  const sections = tjGetCheckedCreateSections();
  const backgroundFile = tjGetFileName('tjBackgroundFile');
  const artworkFile = tjGetFileName('tjArtworkFile');

  const sectionText = sections.length ? sections.join(', ') : 'Journal writing pages';

  const backgroundInstructions = backgroundFile
    ? `BACKGROUND FILE ATTACHED: ${backgroundFile}\nUse the attached background as the original source artwork. Preserve the exact visual identity.`
    : 'No custom background is attached. Create a background that matches the requested style and colors.';

  const artworkInstructions = artworkFile
    ? `ARTWORK FILE ATTACHED: ${artworkFile}\nUse the attached artwork exactly as the original source wherever appropriate.`
    : 'No separate custom artwork is attached.';

  const prompt = `Create a premium, finished ${productType} in Canva.

PRODUCT:
${productType}

FINAL FORMAT:
${formatType}

STYLE:
${styleType}

COLOR PALETTE:
${colorPalette}

PAGES OR SECTIONS TO INCLUDE:
${sectionText}

${backgroundInstructions}

${artworkInstructions}

USER DIRECTION:
${extraDirection || 'Make this feel polished, useful, attractive, cohesive, beginner friendly, and sellable as a premium digital product. Use generous writing space and keep all pages visually consistent.'}

IMPORTANT IMAGE QUALITY LOCK:
If any user-supplied image, background, pattern, logo, illustration, photo, or artwork is attached, treat that file as locked original artwork.
- Do not redraw it.
- Do not regenerate it.
- Do not reinterpret it.
- Do not blur it.
- Do not stretch it.
- Do not distort its proportions.
- Do not change typography contained inside it.
- Do not change important colors or visual details.
- Do not replace it with a similar AI-generated version.
- Do not reduce the apparent image quality.
- Maintain the original aspect ratio.
- If it does not match the required page shape, crop, contain, tile, repeat, or add intentional space around it instead of stretching it.
- If the source image is too small to enlarge cleanly, keep it smaller or tile it rather than making it blurry.

DESIGN REQUIREMENTS:
Create a finished journal design, not a rough concept or plain worksheet.
Use attractive typography that matches the selected style.
Keep labels and writing areas easy to read.
Keep the cover and inside pages visually consistent.
Use balanced spacing and enough room for customers to write.
Make the product look strong enough to sell on Shopify, Etsy, Beacons, Stan Store, or a similar storefront.
Avoid copyrighted characters, brand logos, and trademarked artwork unless the user supplied them and has permission to use them.

CANVA EDITABILITY:
Keep text areas, page titles, shapes, dividers, and common design elements editable whenever possible.
Use clean, modular page layouts that are easy for a beginner to customize.

OUTPUT:
Create the journal design first. Keep the design cohesive from cover through all interior pages.`;

  document.getElementById('tjCanvaOutput').value = prompt;
  document.getElementById('tjCanvaOutputWrap').classList.add('show');
  tjShowStatus('tjCanvaStatus', 'success', 'Your Canva AI prompt is ready. Copy it, open Canva AI, attach the same artwork files, and paste the prompt.');
  document.getElementById('tjCanvaOutputWrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

async function tjCopyCanvaPrompt() {
  const output = document.getElementById('tjCanvaOutput');
  if (!output.value.trim()) tjGenerateCanvaPrompt();
  await tjCopyText(output.value, output);
  tjShowStatus('tjCanvaStatus', 'success', 'Prompt copied. Now open Canva AI and attach any artwork you selected here.');
}

function tjOpenCanvaAI() {
  window.open('https://www.canva.com/ai/', '_blank', 'noopener');
}

function tjGenerateSellingKit() {
  const name = document.getElementById('tjSellName').value.trim();
  const type = tjGetSelectedValue('tjSellType');
  const audience = document.getElementById('tjSellAudience').value.trim();
  const marketplace = document.getElementById('tjMarketplace').value;
  const contents = document.getElementById('tjSellContents').value.trim();
  const result = document.getElementById('tjSellResult').value.trim();
  const features = tjGetSellFeatures();

  if (!name) {
    tjShowStatus('tjSellStatus', 'error', 'Add the journal name first.');
    document.getElementById('tjSellName').focus();
    return;
  }

  const requested = features.length
    ? features.join(', ')
    : 'product title, short description, full description, pricing direction, keywords, mockup image plan, benefit bullets, and launch captions';

  const prompt = `Act as a digital product marketing strategist and ecommerce copywriter.

I already have a finished digital journal. Help me turn it into a polished, ready-to-sell product.

PRODUCT NAME:
${name}

PRODUCT TYPE:
${type}

TARGET CUSTOMER:
${audience || 'Define the strongest likely target customer based on the product.'}

MARKETPLACE:
${marketplace}

WHAT IS INSIDE:
${contents || 'Use the product type and title to infer a practical journal structure. Do not invent exaggerated features.'}

CUSTOMER RESULT:
${result || 'Define the clearest practical outcome this journal can help the customer work toward.'}

CREATE THESE ASSETS:
${requested}

WRITING DIRECTION:
- Make the copy feel warm, polished, useful, and commercially strong.
- Avoid hype, fake urgency, and unrealistic promises.
- Focus on the customer's problem, desired outcome, and how the journal helps.
- Keep wording natural and human.
- Do not use long dashes.
- Do not use generic AI language.
- Make the listing easy to scan on mobile.
- If writing for Etsy, use search-friendly phrases naturally.
- If writing for Shopify, prioritize conversion, clarity, benefits, and clean formatting.
- Give practical pricing direction based on the depth and usefulness of the product.
- For mockups, give a clear image-by-image plan that can be recreated in Canva.
- For launch captions, create 3 different angles: problem-aware, transformation-focused, and simple direct offer.

OUTPUT FORMAT:
Organize the answer into clear sections.
Start with the strongest recommended product title.
Then provide the listing copy.
Then pricing direction.
Then keywords or tags.
Then the mockup image plan.
Finish with the launch captions.

Make the finished product feel boutique, intentional, and worth paying for.`;

  document.getElementById('tjSellOutput').value = prompt;
  document.getElementById('tjSellOutputWrap').classList.add('show');
  tjShowStatus('tjSellStatus', 'success', 'Your Journal Selling Kit is ready to copy.');
  document.getElementById('tjSellOutputWrap').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

async function tjCopySellingKit() {
  const output = document.getElementById('tjSellOutput');
  if (!output.value.trim()) tjGenerateSellingKit();
  if (!output.value.trim()) return;
  await tjCopyText(output.value, output);
  tjShowStatus('tjSellStatus', 'success', 'Selling Kit copied.');
}

async function tjCopyText(text, fallbackElement) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    fallbackElement.removeAttribute('readonly');
    fallbackElement.select();
    fallbackElement.setSelectionRange(0, fallbackElement.value.length);
    document.execCommand('copy');
    fallbackElement.setAttribute('readonly', 'readonly');
  }
}

function tjShowStatus(id, type, message) {
  const status = document.getElementById(id);
  status.className = 'tj-status show ' + type;
  status.textContent = message;
}

function tjResetAll() {
  if (!confirm('Start over and clear everything in Try Jen Digital Journal?')) return;

  document.getElementById('tjCreatePath').classList.remove('active');
  document.getElementById('tjSellPath').classList.remove('active');
  document.getElementById('tjCreateWorkflow').classList.remove('active');
  document.getElementById('tjSellWorkflow').classList.remove('active');

  ['tjProductType','tjStyleType','tjColorPalette','tjFormatType','tjSellType','tjMarketplace'].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.selectedIndex = 0;
  });

  [
    'tjProductTypeCustom','tjStyleTypeCustom','tjColorPaletteCustom',
    'tjExtraDirection','tjCanvaOutput','tjSellName','tjSellTypeCustom',
    'tjSellAudience','tjSellContents','tjSellResult','tjSellOutput'
  ].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.value = '';
  });

  document.querySelectorAll('.tj-custom-field').forEach(function(el) {
    el.classList.remove('show');
  });

  document.querySelectorAll('#tjCreateWorkflow .tj-checkbox-grid input').forEach(function(check, index) {
    check.checked = index === 0;
  });

  document.querySelectorAll('#tjSellFeatures input').forEach(function(check) {
    check.checked = true;
  });

  ['tjBackgroundFile','tjArtworkFile'].forEach(function(id) {
    const el = document.getElementById(id);
    if (el) el.value = '';
  });

  document.getElementById('tjBackgroundMeta').textContent = 'No background selected';
  document.getElementById('tjArtworkMeta').textContent = 'No artwork selected';
  document.getElementById('tjBackgroundQuality').className = 'tj-quality hidden';
  document.getElementById('tjArtworkQuality').className = 'tj-quality hidden';
  document.getElementById('tjCanvaOutputWrap').classList.remove('show');
  document.getElementById('tjSellOutputWrap').classList.remove('show');

  document.querySelectorAll('.tj-status').forEach(function(status) {
    status.className = 'tj-status';
    status.textContent = '';
  });

  document.getElementById('tjJournalApp').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* Expose section actions for Shopify inline controls */
window.tjChoosePath = tjChoosePath;
window.tjHandleCustom = tjHandleCustom;
window.tjInspectImage = tjInspectImage;
window.tjGenerateCanvaPrompt = tjGenerateCanvaPrompt;
window.tjCopyCanvaPrompt = tjCopyCanvaPrompt;
window.tjOpenCanvaAI = tjOpenCanvaAI;
window.tjGenerateSellingKit = tjGenerateSellingKit;
window.tjCopySellingKit = tjCopySellingKit;
window.tjResetAll = tjResetAll;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-jen-invites-v1"] && !Shopify.designMode) return;
  try {
    
var tjiEvent='Wedding';
var tjiHeroObjectUrl='';
var tjiGalleryObjectUrls=[];
var tjiSectionBgUrls={};
var tjiBackgroundMode='jen';

function tjiSetBackgroundMode(mode){
  tjiBackgroundMode=mode==='custom'?'custom':'jen';
  var uploads=document.getElementById('tjiBackgroundUploads');
  var help=document.getElementById('tjiBackgroundHelp');
  if(uploads)uploads.classList.toggle('show',tjiBackgroundMode==='custom');
  if(help)help.textContent=tjiBackgroundMode==='custom'?'Upload a background for any section you want to customize. Your images will appear immediately in the live phone preview.':'Jen will choose cohesive section backgrounds that match your event, invite experience, vibe and color palette.';
  tjiUpdatePreview();
}

function tjiChooseEvent(button){
  document.querySelectorAll('#tjiApp .tji-event').forEach(function(x){x.classList.remove('active')});
  button.classList.add('active'); tjiEvent=button.dataset.event;
  var labels={Wedding:"Couple's names",Birthday:"Birthday person's name", "Baby Shower":"Parent / honoree name"};
  document.getElementById('tjiNamesLabel').textContent=labels[tjiEvent];
  document.querySelectorAll('#tjiApp .tji-event-extra').forEach(function(x){x.classList.toggle('show',x.dataset.for===tjiEvent)});
  tjiApplyRecommendations(); tjiUpdatePreview();
}
function tjiChooseOne(cls,button){
  document.querySelectorAll('#tjiApp .'+cls).forEach(function(x){x.classList.remove('active')});
  button.classList.add('active'); tjiUpdatePreview();
}
function tjiSelected(cls){
  var x=document.querySelector('#tjiApp .'+cls+'.active'); return x?x.dataset.value:'';
}
function tjiExperienceRecipe(name){
  var recipes={
    'Envelope Reveal':'ART DIRECTOR BRIEF: Begin with a refined stationery moment inspired by premium digital invitation studios. Use a full-screen paper or textured envelope composition, restrained monogram or event title, realistic layered paper depth, and a deliberate reveal into the invitation. After opening, change composition completely: editorial hero portrait, oversized names, then alternating image-led and typography-led scenes. Never use a generic blue envelope, app UI, card grid, or repeated centered blocks.',
    'Scrolling Website':'ART DIRECTOR BRIEF: Build a continuous editorial invitation story with 5 to 8 visually distinct scenes. Alternate full-bleed photography, oversized typography, negative-space scenes, split editorial layouts and asymmetric collages. Each screen should have its own composition while sharing one art direction. Avoid templates that look like a business landing page.',
    'Cinematic Photo':'ART DIRECTOR BRIEF: Treat photography like a luxury campaign. Use full-bleed portrait crops, dramatic scale changes, restrained typography over negative space, slow visual pacing and occasional near-black or tonal transition scenes. Do not place text in generic boxes over every image.',
    'Modern Editorial':'ART DIRECTOR BRIEF: Design like an experienced editorial designer using Canva Pro. Use sophisticated serif typography paired with a clean sans serif, intentional asymmetry, cropped photography, thin rules, small uppercase labels, oversized type and strong whitespace. Reference premium fashion/editorial composition, not SaaS cards or social templates.',
    'Playful Illustrated':'ART DIRECTOR BRIEF: Use a professionally illustrated invitation system, not clip-art scattered around a page. Choose one cohesive illustration language and repeat only a few motifs at varied scale. Combine large illustrated scenes with clean typography and breathing room. Keep it boutique, charming and polished rather than childish or sticker-like.',
    'Luxury Celebration':'ART DIRECTOR BRIEF: Build a high-end celebration invitation with dramatic scale, elegant serif typography, rich photography, refined textures, restrained metallic-style accents and ceremonial spacing. Use fewer, larger elements. Avoid excessive gold gradients, sparkle clutter, badges, cards and generic luxury clichés.'
  };
  return recipes[name]||recipes['Scrolling Website'];
}

function tjiEventStory(eventType){
  if(eventType==='Wedding') return 'Opening/reveal > couple names and date > welcome > photo/story moment > countdown > ceremony/reception details > schedule > gallery > dress code > directions > RSVP > registry if selected > closing.';
  if(eventType==='Birthday') return 'Opening/reveal > honoree and celebration title > date/countdown > hero moment > party details > gallery/video > dress code > directions > RSVP > music if selected > closing.';
  return 'Opening/reveal > honoree/baby celebration title > date/countdown > welcome > photo/illustrated moment > shower details > registry > directions > RSVP > gallery > closing.';
}
function tjiApplyRecommendations(){
  var values={
    Wedding:['Animated opening','RSVP form','Live countdown','Map and directions','Event schedule','Photo gallery','Closing thank-you section'],
    Birthday:['Animated opening','RSVP form','Live countdown','Music player','Dress code','Photo gallery','Closing thank-you section'],
    'Baby Shower':['Animated opening','RSVP form','Live countdown','Map and directions','Registry or gift link','Photo gallery','Closing thank-you section']
  };
  var copy={
    Wedding:'Wedding starter: RSVP, countdown, map, schedule, gallery and closing are selected.',
    Birthday:'Birthday starter: RSVP, countdown, music, dress code, gallery and closing are selected.',
    'Baby Shower':'Baby Shower starter: RSVP, countdown, map, registry, gallery and closing are selected.'
  };
  document.querySelectorAll('#tjiFeatures input').forEach(function(x){x.checked=values[tjiEvent].indexOf(x.value)>-1});
  document.getElementById('tjiRecommendation').textContent=copy[tjiEvent];
}
function tjiFeatures(){
  return Array.from(document.querySelectorAll('#tjiFeatures input:checked')).map(function(x){return x.value});
}
function tjiFileNames(id){
  var el=document.getElementById(id); if(!el.files||!el.files.length)return [];
  return Array.from(el.files).map(function(f){return f.name});
}
function tjiListFiles(input,metaId){
  var meta=document.getElementById(metaId);
  meta.textContent=input.files&&input.files.length?Array.from(input.files).map(function(f){return f.name}).join(', '):'No file selected';
}
function tjiInspectHero(input){
  tjiListFiles(input,'tjiHeroMeta');
  if(tjiHeroObjectUrl){URL.revokeObjectURL(tjiHeroObjectUrl);tjiHeroObjectUrl=''}
  if(!input.files||!input.files.length){tjiApplyHeroPreview();return}
  tjiHeroObjectUrl=URL.createObjectURL(input.files[0]);
  tjiApplyHeroPreview();
}
function tjiInspectGallery(input){
  tjiListFiles(input,'tjiGalleryMeta');
  tjiGalleryObjectUrls.forEach(function(url){URL.revokeObjectURL(url)});
  tjiGalleryObjectUrls=[];
  if(input.files&&input.files.length){
    Array.from(input.files).slice(0,3).forEach(function(file){tjiGalleryObjectUrls.push(URL.createObjectURL(file))});
  }
  var cells=document.querySelectorAll('#tjiPreviewGallery div');
  cells.forEach(function(cell,i){
    cell.classList.toggle('tji-gallery-photo',!!tjiGalleryObjectUrls[i]);
    cell.style.backgroundImage=tjiGalleryObjectUrls[i]?'url("'+tjiGalleryObjectUrls[i]+'")':'';
  });
}
function tjiSetSectionBackground(input,targetId,thumbId){
  var key=input.id;
  if(tjiSectionBgUrls[key]){URL.revokeObjectURL(tjiSectionBgUrls[key]);delete tjiSectionBgUrls[key]}
  var target=document.getElementById(targetId),thumb=document.getElementById(thumbId);
  if(!input.files||!input.files.length){
    if(targetId==='tjiPreviewHero'){tjiApplyHeroPreview()}else if(target){target.style.backgroundImage='';target.classList.remove('tji-has-bg')}
    if(thumb){thumb.style.backgroundImage='';thumb.textContent='No background'}
    return;
  }
  var url=URL.createObjectURL(input.files[0]);tjiSectionBgUrls[key]=url;
  if(target){target.style.backgroundImage='url("'+url+'")';if(targetId!=='tjiPreviewHero')target.classList.add('tji-has-bg')}
  if(thumb){thumb.style.backgroundImage='url("'+url+'")';thumb.textContent=''}
}
function tjiApplyHeroPreview(){
  var hero=document.getElementById('tjiPreviewHero');if(!hero)return;
  var bg=tjiSectionBgUrls.tjiBgHero||tjiHeroObjectUrl||'';
  hero.style.backgroundImage=bg?'url("'+bg+'")':'';
}
function tjiBackgroundFileSummary(){
  if(tjiBackgroundMode!=='custom')return 'Let Jen choose cohesive section backgrounds based on the selected event, experience, vibe and color palette.';
  var labels={tjiBgHero:'Opening / hero',tjiBgWelcome:'Welcome',tjiBgCountdown:'Countdown',tjiBgDetails:'Details',tjiBgGallery:'Gallery',tjiBgSchedule:'Schedule',tjiBgDress:'Dress code',tjiBgMap:'Location',tjiBgRegistry:'Registry',tjiBgRsvp:'RSVP',tjiBgClosing:'Closing'};
  var lines=[];Object.keys(labels).forEach(function(id){var el=document.getElementById(id);if(el&&el.files&&el.files[0])lines.push(labels[id]+': '+el.files[0].name)});
  return lines.length?lines.join('\n'):'No custom section backgrounds attached';
}
function tjiExperienceClass(name){
  var map={
    'Envelope Reveal':'tji-experience-envelope',
    'Scrolling Website':'tji-experience-scroll',
    'Cinematic Photo':'tji-experience-cinematic',
    'Modern Editorial':'tji-experience-editorial',
    'Playful Illustrated':'tji-experience-playful',
    'Luxury Celebration':'tji-experience-luxury'
  };
  return map[name]||'tji-experience-scroll';
}

function tjiUpdatePreview(){
  var names=document.getElementById('tjiNames').value.trim();
  var date=document.getElementById('tjiDate').value.trim();
  var time=document.getElementById('tjiTime').value.trim();
  var venue=document.getElementById('tjiVenue').value.trim();
  var location=document.getElementById('tjiLocation').value.trim();
  var msg=document.getElementById('tjiMessage').value.trim();
  var experience=tjiSelected('tji-experience')||'Envelope Reveal';
  var displayName=names||(tjiEvent==='Wedding'?'Jordan & Taylor':tjiEvent==='Birthday'?'Your Name':'Baby Celebration');
  var displayDate=date||'Your event date';

  document.getElementById('tjiPreviewKicker').textContent=tjiEvent+' Invitation';
  document.getElementById('tjiPreviewTitle').textContent=displayName;
  document.getElementById('tjiPreviewDate').textContent=displayDate;
  document.getElementById('tjiPreviewMessage').textContent=msg||'Your invitation message will appear here.';
  document.getElementById('tjiPreviewExperience').textContent=experience;

  document.getElementById('tjiCoverKicker').textContent=tjiEvent+' Invitation';
  document.getElementById('tjiEnvelopeNames').textContent=displayName;
  document.getElementById('tjiEnvelopeDate').textContent=displayDate;
  document.getElementById('tjiCoverTitle').textContent=tjiEvent==='Wedding'?"You're Invited":tjiEvent==='Birthday'?'Come Celebrate':'A Sweet Celebration';

  document.getElementById('tjiDetailDate').textContent=displayDate;
  document.getElementById('tjiDetailTime').textContent=time||'Event time';
  document.getElementById('tjiDetailVenue').textContent=venue||'Venue name';
  document.getElementById('tjiDetailLocation').textContent=location||'City / location';
  document.getElementById('tjiPreviewMapVenue').textContent=venue||'Venue & Directions';
  document.getElementById('tjiPreviewMapLocation').textContent=location||'Add the venue and location to preview this section.';
  document.getElementById('tjiPreviewScheduleText').textContent=document.getElementById('tjiSchedule').value.trim()||'Add your timeline and Jen will turn it into a polished event sequence.';
  document.getElementById('tjiPreviewRsvpText').textContent=document.getElementById('tjiRsvpDetails').value.trim()||'Let us know if you can celebrate with us.';

  var site=document.getElementById('tjiPreviewSite');
  site.className='tji-preview-site '+tjiExperienceClass(experience);

  var selected=tjiFeatures();
  document.querySelectorAll('#tjiPreviewSite [data-feature]').forEach(function(section){
    section.style.display=selected.indexOf(section.dataset.feature)>-1?'flex':'none';
  });

  var music=document.getElementById('tjiPreviewMusic');
  music.classList.toggle('show',selected.indexOf('Music player')>-1);

  document.getElementById('tjiGalleryTitle').textContent=tjiEvent==='Wedding'?'Our Story':tjiEvent==='Birthday'?'Favorite Moments':'Sweet Moments';
  document.getElementById('tjiRegistryTitle').textContent=tjiEvent==='Baby Shower'?'Baby Registry':'Registry & Gifts';
  document.getElementById('tjiPreviewDetailsTitle').textContent=tjiEvent==='Birthday'?'Party Details':tjiEvent==='Baby Shower'?'Shower Details':'Save the Date';
  document.getElementById('tjiPreviewClosingTitle').textContent=tjiEvent==='Birthday'?"Let's Celebrate":tjiEvent==='Baby Shower'?'We Cannot Wait To Celebrate With You':"We Can't Wait To Celebrate";

  tjiUpdateCountdown();
}

function tjiUpdateCountdown(){
  var raw=document.getElementById('tjiDate').value.trim();
  var out=document.getElementById('tjiCountdownValue');
  if(!raw){out.innerHTML='00 : 00 : 00<small>Days · Hours · Minutes</small>';return}
  var target=new Date(raw);
  if(isNaN(target.getTime())){out.innerHTML='SAVE THE DATE<small>'+raw+'</small>';return}
  var diff=Math.max(0,target.getTime()-Date.now());
  var days=Math.floor(diff/86400000);
  var hours=Math.floor((diff%86400000)/3600000);
  var mins=Math.floor((diff%3600000)/60000);
  out.innerHTML=String(days).padStart(2,'0')+' : '+String(hours).padStart(2,'0')+' : '+String(mins).padStart(2,'0')+'<small>Days · Hours · Minutes</small>';
}

function tjiOpenPreview(){
  var cover=document.getElementById('tjiPreviewCover');
  var phone=document.getElementById('tjiPhoneScroll');
  var hint=document.getElementById('tjiScrollHint');
  if(!cover||!phone)return;
  cover.classList.add('opening');
  setTimeout(function(){
    cover.classList.add('open');
    phone.scrollTop=0;
    hint.classList.add('show');
    setTimeout(function(){hint.classList.remove('show')},2200);
  },520);
}

function tjiClosePreview(){
  var cover=document.getElementById('tjiPreviewCover');
  var phone=document.getElementById('tjiPhoneScroll');
  if(!cover||!phone)return;
  phone.scrollTop=0;
  cover.classList.remove('open','opening');
}

function tjiTogglePreviewMusic(){
  var btn=document.getElementById('tjiPreviewMusic');
  if(!btn)return;
  btn.classList.toggle('playing');
  btn.textContent=btn.classList.contains('playing')?'♫':'♪';
}

function tjiPreviewPulse(){tjiOpenPreview()}


var tjiCreatePath='ai';
var tjiGuideSteps=[];
var tjiGuideIndex=0;

function tjiChooseCreatePath(path){
  tjiCreatePath=path;
  document.getElementById('tjiAiPath').classList.toggle('active',path==='ai');
  document.getElementById('tjiFreePath').classList.toggle('active',path==='free');
  document.getElementById('tjiAiWorkflow').classList.toggle('show',path==='ai');
  document.getElementById('tjiFreeWorkflow').classList.toggle('show',path==='free');
}

function tjiOpenCanvaWebsite(){
  window.open('https://www.canva.com/website-builder/?utm_source=chatgpt.com','_blank','noopener');
}

function tjiGuideData(){
  var names=document.getElementById('tjiNames').value.trim();
  var date=document.getElementById('tjiDate').value.trim();
  var time=document.getElementById('tjiTime').value.trim();
  var venue=document.getElementById('tjiVenue').value.trim();
  var location=document.getElementById('tjiLocation').value.trim();
  var message=document.getElementById('tjiMessage').value.trim();
  var colors=document.getElementById('tjiColors').value.trim();
  var experience=tjiSelected('tji-experience')||'Envelope Reveal';
  var motion=tjiSelected('tji-motion')||'Soft & Elegant';
  var vibe=document.getElementById('tjiVibe').value;
  var features=tjiFeatures();
  return {
    names:names,date:date,time:time,venue:venue,location:location,message:message,
    colors:colors||'Use a cohesive palette that matches '+vibe,
    experience:experience,motion:motion,vibe:vibe,features:features
  };
}

function tjiHasFeature(data,name){return data.features.indexOf(name)>-1}

function tjiBuildGuideSteps(){
  var d=tjiGuideData();
  var steps=[];

  steps.push({
    title:'Set Up Your Canva Website',
    intro:'Start a new Canva Website design. This gives you the long vertical canvas needed for the invitation experience.',
    doList:[
      'Open Canva Website Builder using the button below.',
      'Choose a blank website or a simple website template you are comfortable editing.',
      'Design for mobile first. Keep important text large, centered or intentionally aligned, and easy to read on a phone.',
      'Use '+d.colors+' as your working color direction.',
      'Style direction: '+d.vibe+'.'
    ],
    canva:'Do not worry about making it perfect yet. First create the website canvas and establish your colors and typography.'
  });

  steps.push({
    title:'Set the Scroll Movement',
    intro:'Give the invitation the elegant movement of a premium digital invitation website.',
    doList:[
      'Use Canva Rise for headings, names, dates, short copy, buttons and timeline text.',
      'Use Canva Pan for hero photos, venue photos, gallery images and larger decorative elements.',
      'Alternate Pan direction from scene to scene when it improves the composition.',
      'Stagger each scene: heading first, visual second, supporting text third, button last.',
      'Keep animations slow and refined. Avoid bounce, spin, flashing and aggressive zoom effects.',
      'Preview the website while scrolling. Each new section should feel like it is entering the screen.'
    ],
    canva:'Select an element, choose Animate, then use Rise or Pan where available. Preview every few sections so the motion stays elegant instead of busy.'
  });

  steps.push({
    title:d.experience==='Envelope Reveal'?'Build the Opening Reveal':'Build the Opening Scene',
    intro:'This is the first thing guests see, so make it feel intentional before they reach the event details.',
    doList:[
      d.experience==='Envelope Reveal'?'Create an envelope, invitation cover, or elegant opening composition with a clear "Tap to Open" style cue. In regular Canva this can be a visual opening section rather than a true programmed envelope interaction.':'Create a full-height opening section that matches the '+d.experience+' experience.',
      'Add: '+(d.names||'your event or honoree name')+'.',
      'Add: '+(d.date||'your event date')+'.',
      'Keep the opening uncluttered. One strong visual moment is better than several small elements.',
      'Movement direction: '+d.motion+'. Use Canva Rise for the main title/text and Pan for the main visual so the scene enters elegantly as the guest scrolls.'
    ],
    canva:'Search Canva Elements or Templates for visual pieces that fit the opening. Keep all names, dates and decorative elements editable.'
  });

  steps.push({
    title:'Create the Hero Story',
    intro:'Now reveal the main invitation after the opening moment.',
    doList:[
      'Add a tall hero section using your uploaded hero photo if you selected one.',
      'Add the event title/name: '+(d.names||'your event name')+'.',
      'Add the date: '+(d.date||'your event date')+'.',
      d.message?'Use this invitation message: "'+d.message+'"':'Add a short invitation message beneath the names.',
      'Use generous spacing and let the photo or typography carry the section.'
    ],
    canva:'If you uploaded a hero photo to Try Jen, upload the same original photo to Canva. Do not stretch or regenerate it. Crop it cleanly for the mobile layout.'
  });

  if(tjiHasFeature(d,'Live countdown')){
    steps.push({
      title:'Add the Countdown Moment',
      intro:'Create anticipation before the practical event details.',
      doList:[
        'Add a new section titled "Counting Down" or similar.',
        'Feature '+(d.date||'the event date')+' prominently.',
        'Use a simple days / hours / minutes visual if you want the countdown look.',
        'If your Canva setup does not provide a truly live countdown, do not pretend it is live. Use the event date or link to an external countdown tool instead.'
      ],
      canva:'Keep this section visually simple and dramatic. Large numbers or a large date work well on mobile.'
    });
  }

  steps.push({
    title:'Add Event Details',
    intro:'Give guests the practical information they need without turning the invitation into a plain information sheet.',
    doList:[
      'Date: '+(d.date||'add your date')+'.',
      'Time: '+(d.time||'add your event time')+'.',
      'Venue: '+(d.venue||'add your venue')+'.',
      'Location: '+(d.location||'add your city or location')+'.',
      'Use a clean editorial layout, icons, or a simple two-column arrangement instead of several bulky cards.'
    ],
    canva:'Keep this section easy to scan. On mobile, the date, time and location should be readable without zooming.'
  });

  if(tjiHasFeature(d,'Photo gallery')){
    steps.push({
      title:'Build the Photo Story',
      intro:'Use the gallery as a visual break between information sections.',
      doList:[
        'Upload the same gallery photos you selected in Try Jen.',
        'Use 2 to 4 strong images rather than squeezing many tiny photos into one screen.',
        'Mix full-width photos with cropped editorial images.',
        'Use Canva Pan on the larger gallery image and Rise on the gallery heading/caption. Alternate Pan direction on supporting photos when possible.'
      ],
      canva:'Preserve faces and original photo proportions. Crop rather than stretch.'
    });
  }

  if(tjiHasFeature(d,'Event schedule')){
    steps.push({
      title:'Add the Event Schedule',
      intro:'Turn the timeline into a clean vertical story.',
      doList:[
        document.getElementById('tjiSchedule').value.trim()||'Add each important event time in chronological order.',
        'Use a vertical timeline, clean text blocks, or simple dividers.',
        'Keep each timeline item short so it remains easy to scan on a phone.'
      ],
      canva:'Use editable text for every time and activity so the seller can quickly customize the template for another customer.'
    });
  }

  if(tjiHasFeature(d,'Dress code')){
    steps.push({
      title:'Add Dress Code',
      intro:'Give guests a quick visual cue for the expected look.',
      doList:[
        'Add a short Dress Code section.',
        'Use the event-specific details you entered as your wording source.',
        'Optionally add a small color palette or fashion-inspired visual reference that matches '+d.vibe+'.'
      ],
      canva:'Keep this section stylish and concise. It should support the invitation rather than dominate it.'
    });
  }

  if(tjiHasFeature(d,'Map and directions')){
    steps.push({
      title:'Add Directions',
      intro:'Make it easy for guests to get from the invitation to the venue.',
      doList:[
        'Show '+(d.venue||'the venue name')+' and '+(d.location||'the location')+'.',
        'Add a button that says "Get Directions".',
        'Select the button in Canva and attach the real Google Maps or map destination URL.',
        'Test the link before publishing.'
      ],
      canva:'Use Canva Link controls to make the directions button clickable on the published website.'
    });
  }

  if(tjiHasFeature(d,'Registry or gift link')){
    steps.push({
      title:tjiEvent==='Baby Shower'?'Add the Baby Registry':'Add Registry or Gift Link',
      intro:'Create a clear destination without making the invitation feel sales-heavy.',
      doList:[
        'Add one short registry or gift message.',
        'Create a button such as "'+(tjiEvent==='Baby Shower'?'View Baby Registry':'View Registry')+'".',
        'Attach this destination: '+(document.getElementById('tjiRegistry').value.trim()||'your real registry or gift URL')+'.',
        'Test the button after publishing.'
      ],
      canva:'Keep the button easy to find and use a real link. Do not type a URL as plain text unless you also make it clickable.'
    });
  }

  if(tjiHasFeature(d,'RSVP form')){
    steps.push({
      title:'Connect the RSVP',
      intro:'The invitation needs a real place for guests to respond.',
      doList:[
        'Create a prominent "RSVP Now" button.',
        document.getElementById('tjiRsvpDetails').value.trim()?'Your requested RSVP information: '+document.getElementById('tjiRsvpDetails').value.trim()+'.':'Recommended fields: guest name, attending yes/no, guest count and optional message.',
        'Link the RSVP button to the RSVP form or service you plan to use.',
        'Test the RSVP destination on a phone before sharing the invitation.'
      ],
      canva:'For the free workflow, use a real external form/link when Canva does not provide the RSVP data collection you need. The button itself can live inside the Canva website.'
    });
  }

  if(tjiHasFeature(d,'Closing thank-you section')){
    steps.push({
      title:'Create the Closing Scene',
      intro:'Finish the invitation with one intentional final moment.',
      doList:[
        tjiEvent==='Wedding'?'Use a warm closing such as "We Cannot Wait To Celebrate With You."':tjiEvent==='Birthday'?'Use a celebratory closing such as "Let\'s Celebrate."':'Use a warm closing that thanks guests for celebrating this special arrival.',
        'Repeat the event name or date if it strengthens the ending.',
        'If RSVP is selected, repeat the RSVP button once more.',
        'Use one strong photo, illustration, or clean typography composition.'
      ],
      canva:'The ending should feel like the final scene of the invitation, not a website footer.'
    });
  }

  steps.push({
    title:'Preview, Test and Publish',
    intro:'Check the invitation like a guest before you send the link.',
    doList:[
      'Preview the Canva website on mobile.',
      'Scroll from beginning to end and check spacing, text size and image crops.',
      'Test every RSVP, map, registry and external button.',
      'Check that animations feel smooth and do not make the page difficult to read.',
      'Publish the website and copy the Canva public website link.',
      'Open the public link in a private/incognito browser or another phone for one final test.'
    ],
    canva:'Your finished Canva public link is the link you can deliver to the customer or share with guests.'
  });

  return steps;
}

function tjiStartFreeGuide(){
  var names=document.getElementById('tjiNames').value.trim();
  var date=document.getElementById('tjiDate').value.trim();
  if(!names||!date){
    alert('Add the event name and event date first so Jen can personalize your Canva Free guide.');
    document.getElementById(!names?'tjiNames':'tjiDate').focus();
    return;
  }
  tjiGuideSteps=tjiBuildGuideSteps();
  tjiGuideIndex=0;
  document.getElementById('tjiFreeGuide').classList.add('show');
  tjiRenderGuideStep();
  document.getElementById('tjiFreeGuide').scrollIntoView({behavior:'smooth',block:'start'});
}

function tjiRenderGuideStep(){
  if(!tjiGuideSteps.length)return;
  var step=tjiGuideSteps[tjiGuideIndex];
  var total=tjiGuideSteps.length;
  document.getElementById('tjiGuideCounter').textContent='Step '+(tjiGuideIndex+1)+' of '+total;
  document.getElementById('tjiGuideEvent').textContent=tjiEvent+' · '+(tjiSelected('tji-experience')||'Interactive Invite');
  document.getElementById('tjiGuideProgress').style.width=(((tjiGuideIndex+1)/total)*100)+'%';
  document.getElementById('tjiGuideBody').innerHTML=
    '<div class="tji-guide-step-label">Step '+(tjiGuideIndex+1)+'</div>'+
    '<h3>'+step.title+'</h3>'+
    '<p class="tji-guide-intro">'+step.intro+'</p>'+
    '<div class="tji-guide-box"><b>Build this in Canva</b><ul>'+step.doList.map(function(x){return '<li>'+tjiEscapeHtml(x)+'</li>'}).join('')+'</ul></div>'+
    '<div class="tji-guide-box"><b>Jen Tip</b><p>'+tjiEscapeHtml(step.canva)+'</p></div>';
  document.getElementById('tjiGuideBack').disabled=tjiGuideIndex===0;
  document.getElementById('tjiGuideBack').style.opacity=tjiGuideIndex===0?'.45':'1';
  document.getElementById('tjiGuideNext').textContent=tjiGuideIndex===total-1?'Finish Guide':'Done, Next Step';
}

function tjiGuideMove(direction){
  if(!tjiGuideSteps.length)return;
  if(direction>0 && tjiGuideIndex===tjiGuideSteps.length-1){
    document.getElementById('tjiGuideBody').innerHTML=
      '<div class="tji-guide-finish"><div class="tji-guide-step-label">Complete</div><h3>Your Canva build plan is complete</h3><p>Finish the website in Canva, preview it on mobile, test every link, then publish and copy your Canva public website link.</p><button class="tji-btn primary" type="button" onclick="tjiOpenCanvaWebsite()">Open Canva Website Builder</button></div>';
    document.getElementById('tjiGuideActions').style.display='none';
    document.getElementById('tjiGuideProgress').style.width='100%';
    return;
  }
  tjiGuideIndex=Math.max(0,Math.min(tjiGuideSteps.length-1,tjiGuideIndex+direction));
  document.getElementById('tjiGuideActions').style.display='flex';
  tjiRenderGuideStep();
}

function tjiEscapeHtml(value){
  return String(value).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]});
}

function tjiProDesignerDirection(experience,vibe,colors){
  return `PROFESSIONAL DESIGNER STANDARD:
- Act as a senior Canva Pro invitation designer and art director, not a beginner using an AI template generator.
- The finished website must look commercially sellable as a polished $19+ Etsy digital invitation template.
- Start by establishing ONE cohesive art direction from the selected event, ${experience}, ${vibe}, and ${colors||'the chosen premium palette'}.
- Use a deliberate typography system: no more than 2 primary font families plus an optional restrained script accent. Create clear roles for display names, section headings, labels and body copy.
- Favor sophisticated Canva-style font pairings appropriate to the concept, such as an editorial high-contrast serif with a clean modern sans serif. Do not default to generic bold geometric fonts everywhere.
- Build visual hierarchy through scale, whitespace, crop, alignment and contrast, not through rounded boxes.
- Every major scene must be art-directed. Vary composition intentionally: full-bleed hero, negative-space typography, asymmetric photo crop, editorial split, timeline, collage, ceremonial CTA, closing image.
- Use 5 to 8 strong scenes rather than many weak sections. Combine related information when that creates a cleaner composition.
- Maintain consistent margins, type scale, image treatment, decorative language and button style across the entire invitation.
- Use Canva Pro-level details where appropriate: subtle grain/paper texture, elegant frames, image masking, transparency, layered florals or line art, refined shadows, thin rules and tasteful overlays.
- Decorative elements must look curated. Use fewer, larger, intentional accents instead of many tiny AI-generated decorations.
- Photography should be treated professionally: intentional crops, consistent tonal treatment, strong focal points and generous breathing room around faces.
- Buttons should look like part of the invitation design, not app controls. Prefer simple text links, thin-outline buttons or one refined solid CTA style depending on the art direction.
- Do NOT use: repetitive rounded cards, pill buttons, dashboard blocks, icon grids, random gradients, generic blue UI, centered-everything layouts, excessive drop shadows, stock SaaS sections, clip-art clutter, fake glassmorphism, or a different visual style in every section.
- Do NOT make every section white with a heading, paragraph and button. The page needs rhythm and visual surprise.
- Do NOT write filler marketing copy. Invitation copy should be concise, tasteful and event-specific.
- Before finishing, perform a visual quality pass: remove anything that feels generic, beginner-made, overcrowded, inconsistent, or obviously AI-generated.
- The final result should look like a human designer with strong Canva Pro skills spent time composing it, not like Canva AI accepted its first default layout.`;
}

function tjiGenerate(){
  var names=document.getElementById('tjiNames').value.trim();
  var date=document.getElementById('tjiDate').value.trim();
  if(!names||!date){
    tjiShow('error','Add the event name and event date before creating the invite.');
    document.getElementById(!names?'tjiNames':'tjiDate').focus(); return;
  }
  var experience=tjiSelected('tji-experience'), motion=tjiSelected('tji-motion');
  var features=tjiFeatures();
  var eventExtra=tjiEvent==='Wedding'?document.getElementById('tjiWeddingExtra').value.trim():tjiEvent==='Birthday'?document.getElementById('tjiBirthdayExtra').value.trim():document.getElementById('tjiBabyExtra').value.trim();
  var hero=tjiFileNames('tjiHeroFile'),gallery=tjiFileNames('tjiGalleryFiles'),video=tjiFileNames('tjiVideoFile');
  var prompt=`CREATE THE ACTUAL FUNCTIONING MOBILE-FIRST INTERACTIVE INVITATION WEBSITE NOW.

Do not create a static invitation, flyer, presentation, storyboard, mockup, explanation, tutorial, or design concept.
Do not merely describe what the website could look like.
Build the actual vertically scrolling website experience in Canva with editable sections, working links/buttons where Canva supports them, and animation/movement throughout.

EVENT TYPE:
${tjiEvent}

EVENT / HONOREE NAME:
${names}

DATE:
${date}

TIME:
${document.getElementById('tjiTime').value.trim()||'Use an editable placeholder'}

VENUE:
${document.getElementById('tjiVenue').value.trim()||'Use an editable placeholder'}

LOCATION:
${document.getElementById('tjiLocation').value.trim()||'Use an editable placeholder'}

INVITATION MESSAGE:
${document.getElementById('tjiMessage').value.trim()||'Write a short tasteful invitation line appropriate for this event.'}

EVENT-SPECIFIC DIRECTION:
${eventExtra||'Use tasteful event-appropriate details without inventing personal facts.'}

INVITE EXPERIENCE:
${experience}

MOVEMENT STYLE:
${motion}

VISUAL STYLE / VIBE:
${document.getElementById('tjiVibe').value}

COLOR PALETTE:
${document.getElementById('tjiColors').value.trim()||'Choose a cohesive premium palette that fits the selected vibe.'}

DESIGN QUALITY GATE:
${tjiProDesignerDirection(experience,document.getElementById('tjiVibe').value,document.getElementById('tjiColors').value.trim())}

INTERACTIVE SECTIONS TO INCLUDE:
${features.length?features.join(', '):'Event details and closing section'}

RSVP DETAILS:
${document.getElementById('tjiRsvpDetails').value.trim()||'If RSVP is selected, include guest name, attending yes/no, guest count and a message field.'}

MUSIC:
${document.getElementById('tjiMusic').value.trim()||'If music is selected, create an editable music/player area without inventing a copyrighted song.'}

REGISTRY / GIFT LINK:
${document.getElementById('tjiRegistry').value.trim()||'If selected, create an editable registry or gift button.'}

SCHEDULE:
${document.getElementById('tjiSchedule').value.trim()||'If schedule is selected, create an editable timeline with tasteful placeholder entries rather than inventing event facts.'}

ATTACHED MEDIA:
Hero photo: ${hero.length?hero.join(', '):'None attached'}
Gallery photos: ${gallery.length?gallery.join(', '):'None attached'}
Video: ${video.length?video.join(', '):'None attached'}

BACKGROUND DIRECTION:
${tjiBackgroundFileSummary()}
${tjiBackgroundMode==='custom'?'Use each named background in its matching section. Do not substitute, redraw or regenerate uploaded backgrounds.':'Jen is choosing the backgrounds. Create cohesive, premium backgrounds for each scene that fit the selected event, experience, vibe and color palette. Vary the scenes enough to feel like a story while keeping the full invitation visually consistent.'}

INTERACTIVE STORY ARCHITECTURE:
${tjiEventStory(tjiEvent)}

EXPERIENCE CHOREOGRAPHY:
${tjiExperienceRecipe(experience)}

PREMIUM SCROLL MOTION SYSTEM:
- Use Canva RISE and PAN as the primary animation language throughout the invitation.
- RISE: apply to names, section titles, dates, short body copy, timeline text, buttons, RSVP text and small decorative accents. These elements should gently rise into view as the guest scrolls into each scene.
- PAN: apply to hero photography, gallery photos, venue imagery, gift/registry imagery, florals, illustrations and large decorative elements. Alternate subtle left-to-right and right-to-left pan directions from scene to scene.
- STAGGER each scene instead of revealing everything at once: heading rises first, main image pans in second, supporting copy rises third, action button rises last.
- Give each major scene enough vertical breathing room for its entrance movement to be visible while scrolling.
- Keep movement slow, graceful and premium. No bounce, spin, flashing, abrupt zooms or frantic movement.
- Do not animate every object the same way. Mix Rise and Pan intentionally so the page feels layered and cinematic.
- The page should feel as if each section is arriving onto the screen as the guest scrolls, not as if all content is already sitting there.

REFERENCE-STYLE LAYOUT SYSTEM:
- Build a tall, immersive designer-made digital invitation, not a normal business website and not a stack of generic web cards. Begin from an art-directed composition, not Canva AI default sections.
- Compose one visually complete portrait-oriented scene at a time and let each scene flow vertically into the next.
- Use elegant editorial typography with oversized names, dates and section headings. Pair a sophisticated serif/display face with a clean readable secondary font. Use script only sparingly as an accent.
- Use soft full-bleed backgrounds, subtle paper/satin/light textures, delicate decorative artwork and layered details when appropriate to the chosen style.
- Use intentional asymmetry for photos and information. Alternate image-left/text-right and text-left/image-right compositions when appropriate.
- Frame portrait photography elegantly. Allow florals or decorative details to overlap scene edges slightly so the invitation feels layered and continuous.
- PROGRAM / SCHEDULE: use a vertical timeline with the time and activity aligned beside elegant imagery or icons.
- GALLERY: use an editorial collage, preferably one larger portrait image with two smaller supporting images or another balanced asymmetric composition.
- LOCATIONS: pair venue photography with venue name, address, time and a clear GET DIRECTIONS button.
- DATE / COUNTDOWN: make the date a major visual moment, optionally with a calendar treatment, then place an elegant days / hours / minutes / seconds countdown below it.
- REGISTRY / GIFT: make this a designed scene with a focal gift visual, short message and one strong VIEW REGISTRY button.
- RSVP: create a large typographic RSVP moment with one obvious action button.
- CLOSING: finish ceremonially with a thank-you, photo or decorative visual. Do not make it look like a website footer.
- Avoid repetitive rounded cards, dashboard styling, generic SaaS layouts, plain white boxes and excessive pill-shaped UI.
- Do not make every section use the same composition.
- The primary experience is vertical scrolling, so avoid a desktop-style navigation bar unless it genuinely improves the invitation.

SCENE FLOW EXAMPLES:
Opening/reveal -> hero portrait -> date/countdown -> program/schedule -> gallery -> locations -> registry/gift -> RSVP -> event-specific story/family/music -> closing.
Only include scenes that fit the selected event and enabled sections.

IMMERSIVE INTERACTION DIRECTION:
- The guest should feel like they are entering an invitation experience, not reading a normal event webpage.
- Use a clear opening moment before information-heavy sections.
- Create anticipation between sections with full-screen media, typography moments, layered imagery, decorative transitions and intentional whitespace.
- Do not place every detail inside repetitive cards. Avoid a generic landing-page layout.
- Make each major section feel like a new scene in one continuous story.
- Where Canva supports it, use tap/click interactions, animated entrances, video playback, navigation buttons, links and website animation.
- Keep the experience elegant and usable when an advanced interaction is not supported by Canva.
- Never fake a functional RSVP database, countdown engine or music player. Use Canva-supported links, embeds, elements or the closest editable alternative.
- The creator will publish the finished invitation using Canva's public website link.

WEBSITE EXPERIENCE REQUIREMENTS:
- Design primarily for vertical smartphone viewing.
- Make it feel like one continuous premium invitation website, not separate presentation slides.
- Use a strong opening moment appropriate to "${experience}".
- If Envelope Reveal is selected, create an opening/reveal experience before the main invitation content where Canva supports that interaction.
- Reveal sections progressively as the guest scrolls.
- Apply "${motion}" movement consistently, using Canva Rise and Pan as the dominant scroll entrance effects.
- Use tasteful fade, slide, layered, zoom, parallax-style, or decorative motion as appropriate to the chosen movement style and Canva's supported website animation features.
- Keep motion polished and purposeful. Do not make every element move at once.
- Keep typography highly legible on phones.
- Use generous spacing and touch-friendly buttons.
- Create clear visual hierarchy between names, date, location, details and calls to action.
- Use full-width visual moments between information sections where appropriate.
- If a countdown is selected, create a countdown section or the closest editable/functional Canva-supported version.
- If RSVP is selected, create a prominent RSVP section and functional link/form connection where Canva supports it.
- If Map / directions is selected, include a GET DIRECTIONS button designed for a map URL.
- If Music is selected, include a tasteful music control/player area where Canva supports it.
- If Registry / gift link is selected, include a clear registry/gift button.
- If Photo gallery is selected, create an editorial scrolling gallery using the attached images.
- If Closing section is selected, end with a polished full-screen or near-full-screen final moment and a warm closing message.

MEDIA LOCK:
Treat all user-supplied photos and video as original source media.
Do not redraw, regenerate, reinterpret, distort, stretch, alter faces, replace people, change important visual details, or substitute AI-generated versions.
Preserve original aspect ratios.
Crop or contain media gracefully rather than stretching it.
Use the attached hero photo prominently if provided.
Use attached gallery photos as a cohesive scrolling gallery if provided.
Use attached video as a cinematic section only where Canva supports embedded/uploaded video in the generated website.

EVENT-SPECIFIC UX:
For a Wedding, prioritize romance, couple names, ceremony/reception details, RSVP, schedule, directions and photography.
For a Birthday, prioritize the honoree, celebration mood, RSVP, countdown, music, dress code and photography.
For a Baby Shower, prioritize the honoree/baby celebration, RSVP, registry, directions, countdown and sweet visual storytelling.
Follow the selected event type above and do not add irrelevant event sections.

EDITABILITY:
Keep names, dates, times, addresses, headings, body text, buttons, colors and common layout elements editable in Canva whenever possible.
Use modular sections so a beginner can replace text, photos and links easily.

FINAL QUALITY:
The result must be commercially credible as a premium interactive digital invitation sold by an experienced Canva Pro template designer for approximately $19 or more.
It must feel intentionally designed for a phone.
Reject the first generic AI-looking layout if necessary and refine it. Avoid generic AI styling, clutter, excessive rounded cards, tiny text, repetitive centered sections and unnecessary filler.
Do not invent missing personal information.
Build the website now.

PUBLISHING INTENT:
The creator will publish this invitation using Canva's public website link. Make all RSVP, map, registry, gift and destination buttons easy to replace with the creator's real URLs.`;

  document.getElementById('tjiOutput').value=prompt;
  document.getElementById('tjiOutputWrap').classList.add('show');
  tjiShow('success','Your Canva AI website prompt is ready. Copy it, open Canva AI, attach the same media, and paste the prompt.');
  document.getElementById('tjiOutputWrap').scrollIntoView({behavior:'smooth',block:'start'});
}
async function tjiCopy(){
  var out=document.getElementById('tjiOutput'); if(!out.value.trim()){tjiGenerate();return}
  try{await navigator.clipboard.writeText(out.value)}catch(e){out.removeAttribute('readonly');out.select();document.execCommand('copy');out.setAttribute('readonly','readonly')}
  tjiShow('success','Prompt copied. Open Canva AI and attach any photos or video you selected here.');
}
function tjiOpenCanva(){window.open('https://www.canva.com/ai/','_blank','noopener')}
function tjiShow(type,msg){var x=document.getElementById('tjiStatus');x.className='tji-status show '+type;x.textContent=msg}
function tjiReset(){
  if(!confirm('Start over and clear Try Jen Invites?'))return;
  document.querySelectorAll('#tjiApp input[type="text"],#tjiApp textarea').forEach(function(x){x.value=''});
  document.querySelectorAll('#tjiApp input[type="file"]').forEach(function(x){x.value=''});
  document.getElementById('tjiHeroMeta').textContent='No hero photo selected';
  document.getElementById('tjiGalleryMeta').textContent='No gallery photos selected';
  document.getElementById('tjiVideoMeta').textContent='No video selected';
  document.getElementById('tjiPreviewHero').style.backgroundImage='';
  document.querySelectorAll('#tjiApp .tji-event').forEach(function(x){x.classList.remove('active')});
  var firstEvent=document.querySelector('#tjiApp .tji-event[data-event="Wedding"]');firstEvent.classList.add('active');tjiEvent='Wedding';
  document.querySelectorAll('#tjiApp .tji-experience').forEach(function(x){x.classList.remove('active')});
  document.querySelector('#tjiApp .tji-experience[data-value="Envelope Reveal"]').classList.add('active');
  document.querySelectorAll('#tjiApp .tji-motion').forEach(function(x){x.classList.remove('active')});
  document.querySelector('#tjiApp .tji-motion[data-value="Soft & Elegant"]').classList.add('active');
  document.getElementById('tjiVibe').selectedIndex=0;
  document.getElementById('tjiBackgroundMode').value='jen';tjiSetBackgroundMode('jen');
  document.getElementById('tjiOutput').value='';document.getElementById('tjiOutputWrap').classList.remove('show');
  document.getElementById('tjiStatus').className='tji-status';
  tjiChooseCreatePath('ai');
  document.getElementById('tjiFreeGuide').classList.remove('show');
  document.getElementById('tjiGuideActions').style.display='flex';
  tjiGuideSteps=[];tjiGuideIndex=0;
  document.getElementById('tjiNamesLabel').textContent="Couple's names";
  document.querySelectorAll('#tjiApp .tji-event-extra').forEach(function(x){x.classList.toggle('show',x.dataset.for==='Wedding')});
  tjiGalleryObjectUrls.forEach(function(url){URL.revokeObjectURL(url)});tjiGalleryObjectUrls=[];if(tjiHeroObjectUrl){URL.revokeObjectURL(tjiHeroObjectUrl);tjiHeroObjectUrl=''};Object.keys(tjiSectionBgUrls).forEach(function(key){URL.revokeObjectURL(tjiSectionBgUrls[key])});tjiSectionBgUrls={};document.querySelectorAll('#tjiPreviewGallery div').forEach(function(x){x.style.backgroundImage='';x.classList.remove('tji-gallery-photo')});document.querySelectorAll('#tjiApp .tji-bg-thumb').forEach(function(x){x.style.backgroundImage='';x.textContent='No background'});document.querySelectorAll('#tjiPreviewSite .tji-preview-scene').forEach(function(x){x.style.backgroundImage='';x.classList.remove('tji-has-bg')});tjiApplyHeroPreview();tjiApplyRecommendations();tjiUpdatePreview();tjiClosePreview();document.getElementById('tjiApp').scrollIntoView({behavior:'smooth',block:'start'});
}
window.tjiChooseEvent=tjiChooseEvent;window.tjiChooseOne=tjiChooseOne;window.tjiUpdatePreview=tjiUpdatePreview;
window.tjiInspectHero=tjiInspectHero;window.tjiInspectGallery=tjiInspectGallery;window.tjiSetSectionBackground=tjiSetSectionBackground;window.tjiSetBackgroundMode=tjiSetBackgroundMode;window.tjiListFiles=tjiListFiles;window.tjiGenerate=tjiGenerate;
window.tjiCopy=tjiCopy;window.tjiOpenCanva=tjiOpenCanva;window.tjiReset=tjiReset;window.tjiPreviewPulse=tjiPreviewPulse;window.tjiOpenPreview=tjiOpenPreview;window.tjiClosePreview=tjiClosePreview;window.tjiTogglePreviewMusic=tjiTogglePreviewMusic;
window.tjiChooseCreatePath=tjiChooseCreatePath;window.tjiStartFreeGuide=tjiStartFreeGuide;window.tjiGuideMove=tjiGuideMove;window.tjiOpenCanvaWebsite=tjiOpenCanvaWebsite;
tjiSetBackgroundMode('jen');tjiApplyRecommendations();tjiUpdatePreview();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-jen-plr-2-0"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(!root || root.getAttribute('data-ready') === 'yes') return;
    root.setAttribute('data-ready','yes');

    var output = root.querySelector('[data-tj-output]');
    var listingOutput = root.querySelector('[data-tj-listing-output]');
    var marketingOutput = root.querySelector('[data-tj-marketing-output]');
    var packageOutput = root.querySelector('[data-tj-package-output]');
    var status = root.querySelector('[data-tj-status]');
    var previewFrame = root.querySelector('[data-tj-preview-frame]');
    var progress = root.querySelector('[data-tj-progress]');
    var variationId = makeVariationId();

    function q(selector){ return root.querySelector(selector); }
    function qa(selector){ return Array.prototype.slice.call(root.querySelectorAll(selector)); }
    function field(name){ return root.querySelector('[data-tj-field="' + name + '"]'); }
    function clean(value){ return (value || '').toString().trim(); }
    function safeText(value){ return clean(value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;'); }
    function makeVariationId(){ return 'TJ-FACTORY-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2,7).toUpperCase(); }
    function setStatus(message){ status.textContent = message || ''; if(message){ setTimeout(function(){ status.textContent = ''; },2600); } }
    function slugify(text){ return clean(text).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'') || 'digital-product'; }

    function getData(){
      return {
        ProductType: clean(field('ProductType').value),
        Title: clean(field('Title').value) || 'My Digital Product',
        Niche: clean(field('Niche').value) || 'Personal growth',
        Audience: clean(field('Audience').value) || 'Beginners',
        Problem: clean(field('Problem').value) || 'They need clarity and direction',
        Promise: clean(field('Promise').value) || 'Feel clear, organized, and ready to take action',
        Style: clean(field('Style').value),
        DailyPages: parseInt(clean(field('DailyPages').value),10) || 5,
        PrimaryColor: clean(field('PrimaryColor').value) || '#9B8067',
        BackgroundColor: clean(field('BackgroundColor').value) || '#F7F2EA',
        AccentColor: clean(field('AccentColor').value) || '#D9C8B4',
        TextColor: clean(field('TextColor').value) || '#222222',
        ScriptureBox: clean(field('ScriptureBox').value),
        Gratitude: clean(field('Gratitude').value),
        PrayerRequests: clean(field('PrayerRequests').value),
        Platform: clean(field('Platform').value),
        Welcome: clean(field('Welcome').value),
        Prompts: clean(field('Prompts').value)
      };
    }

    function switchTab(name){
      qa('[data-tj-tab]').forEach(function(tab){ tab.classList.toggle('is-active', tab.getAttribute('data-tj-tab') === name); });
      qa('[data-tj-panel]').forEach(function(panel){ panel.classList.toggle('is-active', panel.getAttribute('data-tj-panel') === name); });
    }

    function markProgress(step){
      var pct = Math.min(100, Math.round((step / 6) * 100));
      if(progress) progress.style.width = pct + '%';
      qa('[data-step]').forEach(function(item){
        var num = parseInt(item.getAttribute('data-step'),10);
        item.classList.toggle('done', num <= step);
      });
    }

    function buildPromptFields(prompts,pageKey){
      var list = prompts.split('\n').map(clean).filter(Boolean);
      if(!list.length){ list = ['What am I focusing on today?','What do I need to write down?','What is my next step?']; }
      return list.map(function(prompt,index){
        return '<div class="journal-field"><label>' + safeText(prompt) + '</label><textarea data-save="' + pageKey + '-prompt-' + index + '" placeholder="Write your thoughts here..."></textarea></div>';
      }).join('\n');
    }

    function buildDailyPages(data){
      var pages = [];
      for(var i = 1; i <= data.DailyPages; i++){
        var key = 'day-' + i;
        var scripture = data.ScriptureBox === 'yes' ? '<div class="journal-field"><label>Scripture, quote, or focus thought</label><input data-save="' + key + '-scripture" type="text" placeholder="Write your verse, quote, or focus thought"></div>' : '';
        var gratitude = data.Gratitude === 'yes' ? '<div class="mini-grid"><div class="journal-field"><label>Gratitude 1</label><input data-save="' + key + '-gratitude-1" type="text" placeholder="I am thankful for..."></div><div class="journal-field"><label>Gratitude 2</label><input data-save="' + key + '-gratitude-2" type="text" placeholder="I am thankful for..."></div><div class="journal-field"><label>Gratitude 3</label><input data-save="' + key + '-gratitude-3" type="text" placeholder="I am thankful for..."></div></div>' : '';
        pages.push('<section class="journal-page" data-page="' + key + '"><div class="page-heading"><p class="eyebrow">Daily Page</p><h2>Day ' + i + '</h2><p>Use this page to reflect, plan, and take action.</p></div><div class="journal-field"><label>Date</label><input data-save="' + key + '-date" type="date"></div>' + scripture + buildPromptFields(data.Prompts,key) + gratitude + '<div class="check-card"><h3>Action checklist</h3><label><input data-save="' + key + '-check-1" type="checkbox"> I completed today’s reflection</label><label><input data-save="' + key + '-check-2" type="checkbox"> I chose my top priority</label><label><input data-save="' + key + '-check-3" type="checkbox"> I took one action step</label><label><input data-save="' + key + '-check-4" type="checkbox"> I reviewed my progress</label></div></section>');
      }
      return pages.join('\n');
    }

    function buildPrayerPage(data){
      if(data.PrayerRequests !== 'yes') return '';
      var rows = '';
      for(var i = 1; i <= 6; i++){
        rows += '<div class="prayer-row"><input data-save="prayer-name-' + i + '" type="text" placeholder="Name or topic"><input data-save="prayer-request-' + i + '" type="text" placeholder="Prayer request"><select data-save="prayer-status-' + i + '"><option value="">Status</option><option value="Waiting">Waiting</option><option value="Answered">Answered</option><option value="Continuing">Continuing</option></select></div>';
      }
      return '<section class="journal-page" data-page="prayer"><div class="page-heading"><p class="eyebrow">Prayer Requests</p><h2>Prayer List</h2><p>Write down what you are praying for and track answered prayers.</p></div><div class="prayer-list">' + rows + '</div></section>';
    }

    function buildStyleCss(data){
      return ':root{--primary:' + data.PrimaryColor + ';--background:' + data.BackgroundColor + ';--accent:' + data.AccentColor + ';--text:' + data.TextColor + ';--card:#ffffff;--muted:rgba(0,0,0,.62);--border:rgba(0,0,0,.14);--shadow:0 18px 45px rgba(0,0,0,.08)}*{box-sizing:border-box}body{margin:0;font-family:Arial,sans-serif;background:var(--background);color:var(--text)}body.dark{--background:#181512;--card:#24201c;--text:#f7f2ea;--muted:rgba(255,255,255,.68);--border:rgba(255,255,255,.16);--shadow:0 18px 45px rgba(0,0,0,.3)}.app{max-width:1180px;margin:0 auto;padding:24px;display:grid;gap:18px}.hero{background:var(--card);border:1px solid var(--border);border-radius:22px;padding:28px;box-shadow:var(--shadow);display:grid;gap:12px;position:relative;overflow:hidden}.hero:before{content:"";position:absolute;width:220px;height:220px;border-radius:999px;background:var(--accent);opacity:.22;right:-80px;top:-90px}.eyebrow{margin:0;text-transform:uppercase;letter-spacing:.13em;font-size:12px;font-weight:800;color:var(--primary)}h1,h2,h3{margin:0;line-height:1.1}h1{font-size:clamp(34px,5vw,62px);letter-spacing:-.05em;max-width:780px}h2{font-size:clamp(26px,3vw,42px);letter-spacing:-.04em}h3{font-size:18px}p{margin:0;line-height:1.55}.promise{max-width:760px;color:var(--muted);font-size:17px}.toolbar{display:flex;gap:10px;flex-wrap:wrap;align-items:center;position:relative;z-index:1}button{border:1px solid var(--border);background:var(--card);color:var(--text);border-radius:999px;padding:11px 15px;font-weight:800;cursor:pointer}button.primary{background:var(--primary);color:#fff;border-color:var(--primary)}button:hover{opacity:.86}.saved{color:var(--muted);font-size:14px;font-weight:700}.dashboard{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px}.stat{background:var(--card);border:1px solid var(--border);border-radius:18px;padding:16px;box-shadow:var(--shadow);display:grid;gap:5px}.stat strong{font-size:26px;color:var(--primary)}.stat span{color:var(--muted);font-size:13px;font-weight:700}.tabs{display:flex;gap:8px;overflow-x:auto;padding:4px 0 10px}.tab{white-space:nowrap;border-radius:999px;background:var(--card)}.tab.active{background:var(--primary);color:#fff}.journal-page{display:none;background:var(--card);border:1px solid var(--border);border-radius:22px;padding:24px;box-shadow:var(--shadow);gap:16px}.journal-page.active{display:grid}.page-heading{display:grid;gap:7px;padding-bottom:8px;border-bottom:1px solid var(--border)}.journal-field{display:grid;gap:7px}label{font-size:14px;font-weight:800}input,textarea,select{width:100%;border:1px solid var(--border);border-radius:14px;background:transparent;color:var(--text);padding:12px;font-size:15px;line-height:1.45}textarea{min-height:120px;resize:vertical;font-family:Arial,sans-serif}.mini-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}.check-card{display:grid;gap:10px;border:1px solid var(--border);border-radius:18px;padding:16px;background:rgba(0,0,0,.025)}.check-card label{display:flex;gap:9px;align-items:center;font-weight:700}.check-card input{width:auto}.prayer-list{display:grid;gap:10px}.prayer-row{display:grid;grid-template-columns:1fr 2fr 160px;gap:10px}.footer-note{text-align:center;color:var(--muted);padding:20px 0 8px;font-size:13px}@media(max-width:800px){.app{padding:14px}.dashboard{grid-template-columns:repeat(2,minmax(0,1fr))}.mini-grid,.prayer-row{grid-template-columns:1fr}.hero,.journal-page{border-radius:18px;padding:18px}}@media print{body{background:#fff}.toolbar,.tabs,.dashboard{display:none}.journal-page{display:grid!important;box-shadow:none;break-after:page}.hero{box-shadow:none;break-after:page}}';
    }

    function buildAppJs(journalKey){
      return "(function(){\n" +
      "var journalKey='" + journalKey + "';\n" +
      "var savedText=document.querySelector('[data-saved]');\n" +
      "var inputs=Array.prototype.slice.call(document.querySelectorAll('[data-save]'));\n" +
      "var pages=Array.prototype.slice.call(document.querySelectorAll('[data-page]'));\n" +
      "var tabs=Array.prototype.slice.call(document.querySelectorAll('[data-go]'));\n" +
      "var completed=document.querySelector('[data-completed]');\n" +
      "var entries=document.querySelector('[data-entries]');\n" +
      "var checks=document.querySelector('[data-checks]');\n" +
      "function storageKey(name){return journalKey+':'+name;}\n" +
      "function showSaved(message){savedText.textContent=message||'Saved';setTimeout(function(){savedText.textContent='Saved';},1200);}\n" +
      "function saveInput(input){var key=input.getAttribute('data-save');if(!key)return;if(input.type==='checkbox'){localStorage.setItem(storageKey(key),input.checked?'true':'false');}else{localStorage.setItem(storageKey(key),input.value);}updateProgress();showSaved('Saved');}\n" +
      "function loadInput(input){var key=input.getAttribute('data-save');if(!key)return;var saved=localStorage.getItem(storageKey(key));if(saved===null)return;if(input.type==='checkbox'){input.checked=saved==='true';}else{input.value=saved;}}\n" +
      "function updateProgress(){var filled=0;var checked=0;inputs.forEach(function(input){if(input.type==='checkbox'){if(input.checked){filled++;checked++;}}else if((input.value||'').trim()){filled++;}});var percent=inputs.length?Math.round((filled/inputs.length)*100):0;completed.textContent=percent+'%';entries.textContent=filled;checks.textContent=checked;}\n" +
      "function goToPage(pageName){pages.forEach(function(page){page.classList.toggle('active',page.getAttribute('data-page')===pageName);});tabs.forEach(function(tab){tab.classList.toggle('active',tab.getAttribute('data-go')===pageName);});window.scrollTo({top:0,behavior:'smooth'});}\n" +
      "inputs.forEach(function(input){loadInput(input);input.addEventListener('input',function(){saveInput(input);});input.addEventListener('change',function(){saveInput(input);});});\n" +
      "tabs.forEach(function(tab){tab.addEventListener('click',function(){goToPage(tab.getAttribute('data-go'));});});\n" +
      "document.querySelector('[data-print]').addEventListener('click',function(){window.print();});\n" +
      "document.querySelector('[data-dark]').addEventListener('click',function(){document.body.classList.toggle('dark');});\n" +
      "document.querySelector('[data-reset]').addEventListener('click',function(){var confirmReset=confirm('This will clear all saved entries for this journal on this device. Continue?');if(!confirmReset)return;inputs.forEach(function(input){var key=input.getAttribute('data-save');localStorage.removeItem(storageKey(key));if(input.type==='checkbox'){input.checked=false;}else{input.value='';}});updateProgress();showSaved('Entries reset');});\n" +
      "updateProgress();\n" +
      "})();";
    }

    function buildIndexHtml(data, mode){
      var journalKey = slugify(data.Title) + '-' + variationId.toLowerCase();
      var tabs = '';
      for(var i = 1; i <= data.DailyPages; i++){ tabs += '<button class="tab" type="button" data-go="day-' + i + '">Day ' + i + '</button>'; }
      if(data.PrayerRequests === 'yes'){ tabs += '<button class="tab" type="button" data-go="prayer">Prayer List</button>'; }
      var scriptTag = mode === 'preview' ? '<scr' + 'ipt>' + buildAppJs(journalKey) + '<' + '/scr' + 'ipt>' : '<scr' + 'ipt src="app.js"><' + '/scr' + 'ipt>';
      var styleTag = mode === 'preview' ? '<style>' + buildStyleCss(data) + '</style>' : '<link rel="stylesheet" href="style.css">';
      return '<!doctype html>\n<html lang="en">\n<head>\n<meta charset="utf-8">\n<meta name="viewport" content="width=device-width, initial-scale=1">\n<title>' + safeText(data.Title) + '</title>\n' + styleTag + '\n</head>\n<body>\n<div class="app"><header class="hero"><p class="eyebrow">' + safeText(data.Style) + '</p><h1>' + safeText(data.Title) + '</h1><p class="promise">' + safeText(data.Promise) + '</p><div class="toolbar"><button class="primary" type="button" data-print>Print Product</button><button type="button" data-reset>Reset Entries</button><button type="button" data-dark>Dark Mode</button><span class="saved" data-saved>Saved</span></div></header><section class="dashboard"><div class="stat"><strong data-completed>0%</strong><span>Completed</span></div><div class="stat"><strong data-days>' + data.DailyPages + '</strong><span>Pages</span></div><div class="stat"><strong data-entries>0</strong><span>Entries Saved</span></div><div class="stat"><strong data-checks>0</strong><span>Boxes Checked</span></div></section><nav class="tabs" data-tabs><button class="tab active" type="button" data-go="welcome">Welcome</button>' + tabs + '<button class="tab" type="button" data-go="final">Final Review</button></nav><main><section class="journal-page active" data-page="welcome"><div class="page-heading"><p class="eyebrow">' + safeText(data.ProductType) + '</p><h2>Start Here</h2><p>' + safeText(data.Welcome) + '</p></div><div class="journal-field"><label>My intention for this product</label><textarea data-save="welcome-intention" placeholder="Write what you want this product to help you with..."></textarea></div><div class="journal-field"><label>What I want to feel more prepared for</label><textarea data-save="welcome-prepared" placeholder="Write your answer here..."></textarea></div><div class="check-card"><h3>Quick start checklist</h3><label><input data-save="welcome-check-1" type="checkbox"> I understand how to use this product</label><label><input data-save="welcome-check-2" type="checkbox"> I am ready to write honestly</label><label><input data-save="welcome-check-3" type="checkbox"> I will come back daily</label></div></section>' + buildDailyPages(data) + buildPrayerPage(data) + '<section class="journal-page" data-page="final"><div class="page-heading"><p class="eyebrow">Final Review</p><h2>Reflection and Next Steps</h2><p>Use this page to review your growth, celebrate progress, and decide what you will carry forward.</p></div><div class="journal-field"><label>What changed while using this product?</label><textarea data-save="final-changed" placeholder="Write your reflection here..."></textarea></div><div class="journal-field"><label>What am I thankful for?</label><textarea data-save="final-thankful" placeholder="Write your gratitude here..."></textarea></div><div class="journal-field"><label>What is my next step?</label><textarea data-save="final-next-step" placeholder="Write your next step here..."></textarea></div></section></main><p class="footer-note">Created with Try Jen Product Builder 2.0. Your entries save on this device only.</p></div>\n' + scriptTag + '\n</body>\n</html>';
    }

    function buildPrintableGuide(data){
      return '<!doctype html><html><head><meta charset="utf-8"><title>' + safeText(data.Title) + ' Printable Guide</title><style>body{font-family:Arial,sans-serif;max-width:850px;margin:0 auto;padding:40px;line-height:1.6;color:#222}h1{font-size:42px;letter-spacing:-.04em}section{break-after:page;border:1px solid #ddd;padding:24px;margin:20px 0}.line{border-bottom:1px solid #bbb;height:32px}</style></head><body><h1>' + safeText(data.Title) + '</h1><p>' + safeText(data.Promise) + '</p><section><h2>Welcome</h2><p>' + safeText(data.Welcome) + '</p></section><section><h2>Daily Reflection</h2><p>Use these lines to write, plan, and reflect.</p><div class="line"></div><div class="line"></div><div class="line"></div><div class="line"></div><div class="line"></div></section><section><h2>Notes</h2><div class="line"></div><div class="line"></div><div class="line"></div><div class="line"></div><div class="line"></div></section></body></html>';
    }

    function buildCoverHtml(data){
      return '<!doctype html><html><head><meta charset="utf-8"><title>Cover</title><style>body{margin:0;font-family:Arial,sans-serif;background:' + data.BackgroundColor + ';color:' + data.TextColor + ';display:grid;place-items:center;min-height:100vh}.cover{width:800px;max-width:90vw;aspect-ratio:4/5;background:#fff;border:1px solid rgba(0,0,0,.12);display:grid;place-items:center;text-align:center;padding:60px}.eyebrow{text-transform:uppercase;letter-spacing:.18em;color:' + data.PrimaryColor + ';font-weight:800}h1{font-size:58px;line-height:1;letter-spacing:-.06em;margin:20px 0}.promise{font-size:20px;line-height:1.5;max-width:560px}</style></head><body><div class="cover"><div><p class="eyebrow">' + safeText(data.ProductType) + '</p><h1>' + safeText(data.Title) + '</h1><p class="promise">' + safeText(data.Promise) + '</p></div></div></body></html>';
    }

    function buildListing(data){
      var tags = [
        data.ProductType.toLowerCase(),
        'digital product',
        'printable planner',
        'digital download',
        data.Audience.toLowerCase().slice(0,20),
        'canva template',
        'instant download',
        'editable template',
        'self care tool',
        'goal planner',
        'journal pages',
        'printable pdf',
        'etsy seller'
      ].map(function(tag){ return tag.replace(/[^a-z0-9 ]/gi,'').slice(0,20); });

      return [
        'ETSY LISTING',
        '',
        'SEO Title:',
        data.Title + ' | ' + data.ProductType + ' for ' + data.Audience + ' | Printable Digital Download, Interactive Planner, Editable Journal',
        '',
        '13 Etsy Tags:',
        tags.join(', '),
        '',
        'Description:',
        'This ' + data.ProductType.toLowerCase() + ' was created for ' + data.Audience.toLowerCase() + ' who want to ' + data.Promise.toLowerCase() + '. It gives buyers a simple, beautiful, and easy to use digital product they can open in their browser, write in, print, and use again.',
        '',
        'Inside you receive:',
        '- Interactive digital product app',
        '- Printable guide',
        '- Cover file',
        '- Customer instructions',
        '- License terms',
        '- Instant download ZIP',
        '',
        'Perfect for:',
        '- ' + data.Audience,
        '- Beginners who need a simple starting point',
        '- Digital download customers',
        '- Planner and journal lovers',
        '- People who want a clean, guided system',
        '',
        'FAQ:',
        'Q: Is this a physical product?',
        'A: No, this is a digital download.',
        '',
        'Q: How do I use it?',
        'A: Open the index.html file in your browser and type directly into the pages.',
        '',
        'Q: Will my entries save?',
        'A: Yes, entries save on the device and browser being used.',
        '',
        'Q: Can I print it?',
        'A: Yes, use the print button or open the printable guide.'
      ].join('\n');
    }

    function getMockups(data){
      return [
        'Etsy thumbnail mockup showing ' + data.Title + ' open on a laptop with neutral boho desk styling, cream background, soft natural light',
        'Lifestyle iPad mockup showing the interactive ' + data.ProductType.toLowerCase() + ' on screen, cozy workspace, coffee, notebook, minimal props',
        'Laptop mockup showing the digital product dashboard with tabs, progress tracker, and clean printable page preview',
        'Clean product mockup showing ZIP download contents: index.html, printable guide, cover, license, read me, arranged neatly',
        'Pinterest style mockup with the product cover, browser preview, and text overlay: ' + data.Promise,
        'Digital download bundle mockup with cover page, printable page, browser app preview, and bonus files displayed on a cream background'
      ];
    }

    function getPinterestPins(data){
      var angles = [
        'Get organized without overwhelm',
        'Start today with clarity',
        'Digital product you can use instantly',
        'Simple printable plus interactive journal',
        'Perfect giftable digital download',
        'A calm planning system for busy people',
        'Stop overthinking and start writing',
        'A beginner friendly tool for daily consistency',
        'Printable and interactive in one product',
        'Your peaceful reset starts here'
      ];
      var pins = [];
      for(var i = 0; i < 10; i++){
        pins.push((i + 1) + '. Pinterest pin idea: ' + data.Title + ' for ' + data.Audience + ' | Angle: ' + angles[i] + ' | Text overlay: "' + angles[i] + '"');
      }
      return pins;
    }

    function getSocialCaptions(data){
      return [
        'Instagram: If you have been needing a simple way to get organized, this ' + data.ProductType.toLowerCase() + ' was made for you. Download it, open it, and start today.',
        'Facebook: I created this ' + data.ProductType.toLowerCase() + ' for ' + data.Audience.toLowerCase() + ' who want to ' + data.Promise.toLowerCase() + '. It is simple, practical, and easy to use.',
        'TikTok: POV: you finally found a digital ' + data.ProductType.toLowerCase() + ' that helps you get clear and stay consistent.',
        'Threads: Simple tools win. This ' + data.ProductType.toLowerCase() + ' helps you stop overthinking and start making progress.',
        'Pinterest description: Download this ' + data.Title + ', a digital ' + data.ProductType.toLowerCase() + ' designed for ' + data.Audience.toLowerCase() + ' who want to ' + data.Promise.toLowerCase() + '.',
        'Short promo caption: Simple, clean, and ready to use. This ' + data.ProductType.toLowerCase() + ' helps you move from overwhelmed to organized.'
      ];
    }

    function buildMockupOutput(data){
      return ['MOCKUP PROMPTS','','Use these prompts in Try Jen Mockup, Canva, Kittl, or your image tool.','',getMockups(data).join('\n\n')].join('\n');
    }

    function buildPinterestOutput(data){
      return ['PINTEREST PIN IDEAS','','Create these as 1000 x 1500 vertical pins. Keep text big and readable.','',getPinterestPins(data).join('\n')].join('\n');
    }

    function buildSocialOutput(data){
      return ['SOCIAL POSTS','','Use these captions to promote the product after listing it.','',getSocialCaptions(data).join('\n\n')].join('\n');
    }

    function buildMarketing(data){
      return [
        buildMockupOutput(data),
        '',
        buildPinterestOutput(data),
        '',
        buildSocialOutput(data)
      ].join('\n');
    }

    function buildLicense(data){
      return [
        data.Title + ' License Terms',
        '',
        'You may use this product for personal use according to the terms of your purchase.',
        '',
        'If commercial rights are included, you may edit, rebrand, and sell your customized version as a finished product.',
        '',
        'You may not give away the original files for free, resell the unedited source files, or claim the original unmodified source as your own unique creation.',
        '',
        'Seller note: Customize the title, cover, examples, colors, and listing before selling.'
      ].join('\n');
    }

    function buildReadMe(data){
      return [
        data.Title,
        '',
        'Thank you for downloading this digital product.',
        '',
        'How to use:',
        '1. Open index.html in your browser.',
        '2. Type directly into the product pages.',
        '3. Your entries autosave on your device.',
        '4. Use the print button when needed.',
        '5. Open printable-guide.html if you prefer a printable version.',
        '',
        'Important:',
        'Entries save inside the browser on the same device. Clearing browser storage may remove saved entries.',
        '',
        'Files included:',
        '- index.html',
        '- style.css',
        '- app.js',
        '- printable-guide.html',
        '- cover.html',
        '- etsy-listing.txt',
        '- mockup-and-marketing-kit.txt',
        '- license.txt',
        '- READ-ME.txt'
      ].join('\n');
    }

    function buildPackageSummary(data){
      return [
        'LAUNCH PACKAGE READY',
        '',
        'Variation ID: ' + variationId,
        '',
        'Product type: ' + data.ProductType,
        'Title: ' + data.Title,
        'Niche: ' + data.Niche,
        'Audience: ' + data.Audience,
        'Problem: ' + data.Problem,
        'Promise: ' + data.Promise,
        'Style: ' + data.Style,
        '',
        'ZIP includes:',
        '- Interactive digital product app',
        '- CSS styling',
        '- JavaScript autosave',
        '- Printable guide HTML',
        '- Cover HTML',
        '- Etsy listing',
        '- 13 Etsy tags',
        '- FAQ',
        '- Mockup prompts',
        '- 10 Pinterest pin ideas',
        '- Social captions',
        '- License terms',
        '- Customer read-me file'
      ].join('\n');
    }

    function generateProductOnly(){
      var data = getData();
      output.value = buildIndexHtml(data, 'download');
      renderPreview();
      packageOutput.value = buildPackageSummary(data);
      markProgress(3);
      setStatus('Interactive product generated');
      switchTab('journal');
    }

    function generateListingOnly(){
      var data = getData();
      listingOutput.value = buildListing(data);
      markProgress(4);
      setStatus('Etsy listing generated');
      switchTab('listing');
    }

    function generateMockupsOnly(){
      var data = getData();
      marketingOutput.value = buildMockupOutput(data);
      markProgress(5);
      setStatus('Mockup prompts generated');
      switchTab('marketing');
    }

    function generatePinterestOnly(){
      var data = getData();
      marketingOutput.value = buildPinterestOutput(data);
      markProgress(5);
      setStatus('Pinterest pins generated');
      switchTab('marketing');
    }

    function generateSocialOnly(){
      var data = getData();
      marketingOutput.value = buildSocialOutput(data);
      markProgress(5);
      setStatus('Social posts generated');
      switchTab('marketing');
    }

    function buildPackageOnly(){
      var data = getData();
      output.value = buildIndexHtml(data, 'download');
      listingOutput.value = buildListing(data);
      marketingOutput.value = buildMarketing(data);
      packageOutput.value = buildPackageSummary(data);
      renderPreview();
      markProgress(6);
      setStatus('Launch package built');
      switchTab('download');
    }

    function generateAll(){
      var data = getData();
      markProgress(1);
      setStatus('Creating product...');
      setTimeout(function(){ markProgress(2); },120);
      setTimeout(function(){ markProgress(3); output.value = buildIndexHtml(data, 'download'); renderPreview(); },260);
      setTimeout(function(){ markProgress(4); listingOutput.value = buildListing(data); },420);
      setTimeout(function(){ markProgress(5); marketingOutput.value = buildMarketing(data); },580);
      setTimeout(function(){ markProgress(6); packageOutput.value = buildPackageSummary(data); setStatus('Your product is ready'); switchTab('journal'); },760);
    }

    function renderPreview(){
      var data = getData();
      previewFrame.srcdoc = buildIndexHtml(data, 'preview');
    }

    function copyText(area,message){
      var text = clean(area.value);
      if(!text){ setStatus('Generate the product first'); return; }
      if(navigator.clipboard){ navigator.clipboard.writeText(text).then(function(){ setStatus(message); }).catch(function(){ area.focus(); area.select(); document.execCommand('copy'); setStatus(message); }); }
      else { area.focus(); area.select(); document.execCommand('copy'); setStatus(message); }
    }

    function downloadFile(filename,content,type){
      var blob = new Blob([content],{type:type || 'text/plain'});
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(function(){ URL.revokeObjectURL(url); },500);
    }

    function downloadHtml(){
      var data = getData();
      downloadFile(slugify(data.Title) + '.html', buildIndexHtml(data, 'preview'), 'text/html');
      setStatus('Single HTML downloaded');
    }

    function loadZipLibrary(callback){
      if(window.JSZip){ callback(); return; }
      var existing = document.querySelector('script[data-jszip-loader]');
      if(existing){ existing.addEventListener('load',callback); return; }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
      script.async = true;
      script.setAttribute('data-jszip-loader','yes');
      script.onload = callback;
      script.onerror = function(){ downloadHtml(); setStatus('ZIP library blocked, HTML downloaded instead'); };
      document.head.appendChild(script);
    }

    function downloadZip(){
      loadZipLibrary(function(){
        var data = getData();
        var journalKey = slugify(data.Title) + '-' + variationId.toLowerCase();
        var folderName = slugify(data.Title);
        var zip = new JSZip();
        zip.folder(folderName).file('index.html', buildIndexHtml(data, 'download'));
        zip.folder(folderName).file('style.css', buildStyleCss(data));
        zip.folder(folderName).file('app.js', buildAppJs(journalKey));
        zip.folder(folderName).file('printable-guide.html', buildPrintableGuide(data));
        zip.folder(folderName).file('cover.html', buildCoverHtml(data));
        zip.folder(folderName).file('etsy-listing.txt', buildListing(data));
        zip.folder(folderName).file('mockup-and-marketing-kit.txt', buildMarketing(data));
        zip.folder(folderName).file('license.txt', buildLicense(data));
        zip.folder(folderName).file('READ-ME.txt', buildReadMe(data));
        zip.generateAsync({type:'blob'}).then(function(blob){
          var url = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.download = folderName + '-launch-package.zip';
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(function(){ URL.revokeObjectURL(url); },500);
          setStatus('Launch ZIP downloaded');
        });
      });
    }

    function newVariation(){ variationId = makeVariationId(); generateAll(); setStatus('New variation created'); }

    qa('[data-tj-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){ switchTab(tab.getAttribute('data-tj-tab')); });
    });

    q('[data-tj-build]').addEventListener('click', generateAll);
    q('[data-tj-generate-product]').addEventListener('click', generateProductOnly);
    q('[data-tj-generate-listing]').addEventListener('click', generateListingOnly);
    q('[data-tj-generate-mockups]').addEventListener('click', generateMockupsOnly);
    q('[data-tj-generate-pinterest]').addEventListener('click', generatePinterestOnly);
    q('[data-tj-generate-social]').addEventListener('click', generateSocialOnly);
    q('[data-tj-build-package]').addEventListener('click', buildPackageOnly);
    q('[data-tj-download-zip-top]').addEventListener('click', downloadZip);
    q('[data-tj-new-top]').addEventListener('click', newVariation);
    q('[data-tj-generate-listing-2]').addEventListener('click', generateListingOnly);
    q('[data-tj-build-package-2]').addEventListener('click', buildPackageOnly);
    q('[data-tj-reset-flow]').addEventListener('click', function(){ markProgress(0); setStatus('Flow reset'); });
    q('[data-tj-copy-listing]').addEventListener('click', function(){ copyText(listingOutput,'Listing copied'); });
    q('[data-tj-copy-marketing]').addEventListener('click', function(){ copyText(marketingOutput,'Marketing kit copied'); });
    q('[data-tj-download-html]').addEventListener('click', downloadHtml);
    q('[data-tj-download-zip]').addEventListener('click', downloadZip);
    q('[data-tj-new]').addEventListener('click', newVariation);

    generateAll();
  }

  function initAll(){
    var roots = document.querySelectorAll('.tj-factory');
    for(var i = 0; i < roots.length; i++){
      initRoot(roots[i]);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event){
    if(event && event.target){
      var roots = event.target.querySelectorAll('.tj-factory');
      for(var i = 0; i < roots.length; i++){
        initRoot(roots[i]);
      }
    } else {
      initAll();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-jen-plr"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(!root || root.getAttribute('data-ready') === 'yes') return;
    root.setAttribute('data-ready','yes');

    var output = root.querySelector('[data-tj-output]');
    var status = root.querySelector('[data-tj-status]');
    var previewFrame = root.querySelector('[data-tj-preview-frame]');
    var variationId = makeVariationId();

    function q(selector){ return root.querySelector(selector); }
    function field(name){ return root.querySelector('[data-tj-field="' + name + '"]'); }
    function clean(value){ return (value || '').toString().trim(); }
    function safeText(value){ return clean(value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;'); }
    function makeVariationId(){ return 'TJ-JOURNAL-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2,7).toUpperCase(); }
    function setStatus(message){ status.textContent = message || ''; if(message){ setTimeout(function(){ status.textContent = ''; },2600); } }
    function slugify(text){ return clean(text).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'') || 'journal'; }

    function getData(){
      return {
        Title: clean(field('Title').value) || 'My Digital Journal',
        Audience: clean(field('Audience').value) || 'Beginners',
        Theme: clean(field('Theme').value),
        Style: clean(field('Style').value),
        PrimaryColor: clean(field('PrimaryColor').value) || '#9B8067',
        BackgroundColor: clean(field('BackgroundColor').value) || '#F7F2EA',
        AccentColor: clean(field('AccentColor').value) || '#D9C8B4',
        TextColor: clean(field('TextColor').value) || '#222222',
        DailyPages: parseInt(clean(field('DailyPages').value),10) || 5,
        ScriptureBox: clean(field('ScriptureBox').value),
        Gratitude: clean(field('Gratitude').value),
        PrayerRequests: clean(field('PrayerRequests').value),
        Promise: clean(field('Promise').value),
        Welcome: clean(field('Welcome').value),
        Prompts: clean(field('Prompts').value)
      };
    }

    function buildPromptFields(prompts,pageKey){
      var list = prompts.split('\n').map(clean).filter(Boolean);
      if(!list.length){ list = ['What am I focusing on today?','What do I need to write down?','What is my next step?']; }
      return list.map(function(prompt,index){
        return '<div class="journal-field"><label>' + safeText(prompt) + '</label><textarea data-save="' + pageKey + '-prompt-' + index + '" placeholder="Write your thoughts here..."></textarea></div>';
      }).join('\n');
    }

    function buildDailyPages(data){
      var pages = [];
      for(var i = 1; i <= data.DailyPages; i++){
        var key = 'day-' + i;
        var scripture = data.ScriptureBox === 'yes' ? '<div class="journal-field"><label>Today\'s scripture or encouragement</label><input data-save="' + key + '-scripture" type="text" placeholder="Write a verse, quote, or focus thought"></div>' : '';
        var gratitude = data.Gratitude === 'yes' ? '<div class="mini-grid"><div class="journal-field"><label>Gratitude 1</label><input data-save="' + key + '-gratitude-1" type="text" placeholder="I am thankful for..."></div><div class="journal-field"><label>Gratitude 2</label><input data-save="' + key + '-gratitude-2" type="text" placeholder="I am thankful for..."></div><div class="journal-field"><label>Gratitude 3</label><input data-save="' + key + '-gratitude-3" type="text" placeholder="I am thankful for..."></div></div>' : '';
        pages.push('<section class="journal-page" data-page="' + key + '"><div class="page-heading"><p class="eyebrow">Daily Journal</p><h2>Day ' + i + '</h2><p>Use this page to pray, plan, reflect, and organize your thoughts for the day.</p></div><div class="journal-field"><label>Date</label><input data-save="' + key + '-date" type="date"></div>' + scripture + buildPromptFields(data.Prompts,key) + gratitude + '<div class="check-card"><h3>Today\'s action checklist</h3><label><input data-save="' + key + '-check-1" type="checkbox"> I prayed before starting my day</label><label><input data-save="' + key + '-check-2" type="checkbox"> I wrote down my top priorities</label><label><input data-save="' + key + '-check-3" type="checkbox"> I encouraged someone today</label><label><input data-save="' + key + '-check-4" type="checkbox"> I reflected before ending the day</label></div></section>');
      }
      return pages.join('\n');
    }

    function buildPrayerRow(index){
      return '<div class="prayer-row"><input data-save="prayer-name-' + index + '" type="text" placeholder="Name or topic"><input data-save="prayer-request-' + index + '" type="text" placeholder="Prayer request"><select data-save="prayer-status-' + index + '"><option value="">Status</option><option value="Waiting">Waiting</option><option value="Answered">Answered</option><option value="Continuing">Continuing</option></select></div>';
    }

    function buildPrayerPage(data){
      if(data.PrayerRequests !== 'yes') return '';
      var rows = '';
      for(var i = 1; i <= 6; i++){ rows += buildPrayerRow(i); }
      return '<section class="journal-page" data-page="prayer"><div class="page-heading"><p class="eyebrow">Prayer Requests</p><h2>Prayer List</h2><p>Write down what you are praying for and come back to mark answered prayers.</p></div><div class="prayer-list">' + rows + '</div></section>';
    }

    function buildStyleCss(data){
      return ':root{--primary:' + data.PrimaryColor + ';--background:' + data.BackgroundColor + ';--accent:' + data.AccentColor + ';--text:' + data.TextColor + ';--card:#ffffff;--muted:rgba(0,0,0,.62);--border:rgba(0,0,0,.14);--shadow:0 18px 45px rgba(0,0,0,.08)}*{box-sizing:border-box}body{margin:0;font-family:Arial,sans-serif;background:var(--background);color:var(--text)}body.dark{--background:#181512;--card:#24201c;--text:#f7f2ea;--muted:rgba(255,255,255,.68);--border:rgba(255,255,255,.16);--shadow:0 18px 45px rgba(0,0,0,.3)}.app{max-width:1180px;margin:0 auto;padding:24px;display:grid;gap:18px}.hero{background:var(--card);border:1px solid var(--border);border-radius:22px;padding:28px;box-shadow:var(--shadow);display:grid;gap:12px;position:relative;overflow:hidden}.hero:before{content:"";position:absolute;width:220px;height:220px;border-radius:999px;background:var(--accent);opacity:.22;right:-80px;top:-90px}.eyebrow{margin:0;text-transform:uppercase;letter-spacing:.13em;font-size:12px;font-weight:800;color:var(--primary)}h1,h2,h3{margin:0;line-height:1.1}h1{font-size:clamp(34px,5vw,62px);letter-spacing:-.05em;max-width:780px}h2{font-size:clamp(26px,3vw,42px);letter-spacing:-.04em}h3{font-size:18px}p{margin:0;line-height:1.55}.promise{max-width:760px;color:var(--muted);font-size:17px}.toolbar{display:flex;gap:10px;flex-wrap:wrap;align-items:center;position:relative;z-index:1}button{border:1px solid var(--border);background:var(--card);color:var(--text);border-radius:999px;padding:11px 15px;font-weight:800;cursor:pointer}button.primary{background:var(--primary);color:#fff;border-color:var(--primary)}button:hover{opacity:.86}.saved{color:var(--muted);font-size:14px;font-weight:700}.dashboard{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px}.stat{background:var(--card);border:1px solid var(--border);border-radius:18px;padding:16px;box-shadow:var(--shadow);display:grid;gap:5px}.stat strong{font-size:26px;color:var(--primary)}.stat span{color:var(--muted);font-size:13px;font-weight:700}.tabs{display:flex;gap:8px;overflow-x:auto;padding:4px 0 10px}.tab{white-space:nowrap;border-radius:999px;background:var(--card)}.tab.active{background:var(--primary);color:#fff}.journal-page{display:none;background:var(--card);border:1px solid var(--border);border-radius:22px;padding:24px;box-shadow:var(--shadow);gap:16px}.journal-page.active{display:grid}.page-heading{display:grid;gap:7px;padding-bottom:8px;border-bottom:1px solid var(--border)}.journal-field{display:grid;gap:7px}label{font-size:14px;font-weight:800}input,textarea,select{width:100%;border:1px solid var(--border);border-radius:14px;background:transparent;color:var(--text);padding:12px;font-size:15px;line-height:1.45}textarea{min-height:120px;resize:vertical;font-family:Arial,sans-serif}.mini-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}.check-card{display:grid;gap:10px;border:1px solid var(--border);border-radius:18px;padding:16px;background:rgba(0,0,0,.025)}.check-card label{display:flex;gap:9px;align-items:center;font-weight:700}.check-card input{width:auto}.prayer-list{display:grid;gap:10px}.prayer-row{display:grid;grid-template-columns:1fr 2fr 160px;gap:10px}.footer-note{text-align:center;color:var(--muted);padding:20px 0 8px;font-size:13px}@media(max-width:800px){.app{padding:14px}.dashboard{grid-template-columns:repeat(2,minmax(0,1fr))}.mini-grid,.prayer-row{grid-template-columns:1fr}.hero,.journal-page{border-radius:18px;padding:18px}}@media print{body{background:#fff}.toolbar,.tabs,.dashboard{display:none}.journal-page{display:grid!important;box-shadow:none;break-after:page}.hero{box-shadow:none;break-after:page}}';
    }

    function buildAppJs(journalKey){
      return "(function(){\n" +
      "var journalKey='" + journalKey + "';\n" +
      "var savedText=document.querySelector('[data-saved]');\n" +
      "var inputs=Array.prototype.slice.call(document.querySelectorAll('[data-save]'));\n" +
      "var pages=Array.prototype.slice.call(document.querySelectorAll('[data-page]'));\n" +
      "var tabs=Array.prototype.slice.call(document.querySelectorAll('[data-go]'));\n" +
      "var completed=document.querySelector('[data-completed]');\n" +
      "var entries=document.querySelector('[data-entries]');\n" +
      "var checks=document.querySelector('[data-checks]');\n" +
      "function storageKey(name){return journalKey+':'+name;}\n" +
      "function showSaved(message){savedText.textContent=message||'Saved';setTimeout(function(){savedText.textContent='Saved';},1200);}\n" +
      "function saveInput(input){var key=input.getAttribute('data-save');if(!key)return;if(input.type==='checkbox'){localStorage.setItem(storageKey(key),input.checked?'true':'false');}else{localStorage.setItem(storageKey(key),input.value);}updateProgress();showSaved('Saved');}\n" +
      "function loadInput(input){var key=input.getAttribute('data-save');if(!key)return;var saved=localStorage.getItem(storageKey(key));if(saved===null)return;if(input.type==='checkbox'){input.checked=saved==='true';}else{input.value=saved;}}\n" +
      "function updateProgress(){var filled=0;var checked=0;inputs.forEach(function(input){if(input.type==='checkbox'){if(input.checked){filled++;checked++;}}else if((input.value||'').trim()){filled++;}});var percent=inputs.length?Math.round((filled/inputs.length)*100):0;completed.textContent=percent+'%';entries.textContent=filled;checks.textContent=checked;}\n" +
      "function goToPage(pageName){pages.forEach(function(page){page.classList.toggle('active',page.getAttribute('data-page')===pageName);});tabs.forEach(function(tab){tab.classList.toggle('active',tab.getAttribute('data-go')===pageName);});window.scrollTo({top:0,behavior:'smooth'});}\n" +
      "inputs.forEach(function(input){loadInput(input);input.addEventListener('input',function(){saveInput(input);});input.addEventListener('change',function(){saveInput(input);});});\n" +
      "tabs.forEach(function(tab){tab.addEventListener('click',function(){goToPage(tab.getAttribute('data-go'));});});\n" +
      "document.querySelector('[data-print]').addEventListener('click',function(){window.print();});\n" +
      "document.querySelector('[data-dark]').addEventListener('click',function(){document.body.classList.toggle('dark');});\n" +
      "document.querySelector('[data-reset]').addEventListener('click',function(){var confirmReset=confirm('This will clear all saved entries for this journal on this device. Continue?');if(!confirmReset)return;inputs.forEach(function(input){var key=input.getAttribute('data-save');localStorage.removeItem(storageKey(key));if(input.type==='checkbox'){input.checked=false;}else{input.value='';}});updateProgress();showSaved('Entries reset');});\n" +
      "updateProgress();\n" +
      "})();";
    }

    function buildIndexHtml(data, mode){
      var journalKey = slugify(data.Title) + '-' + variationId.toLowerCase();
      var tabs = '';
      for(var i = 1; i <= data.DailyPages; i++){ tabs += '<button class="tab" type="button" data-go="day-' + i + '">Day ' + i + '</button>'; }
      if(data.PrayerRequests === 'yes'){ tabs += '<button class="tab" type="button" data-go="prayer">Prayer List</button>'; }
      var scriptTag = mode === 'preview' ? '<scr' + 'ipt>' + buildAppJs(journalKey) + '<' + '/scr' + 'ipt>' : '<scr' + 'ipt src="app.js"><' + '/scr' + 'ipt>';
      var styleTag = mode === 'preview' ? '<style>' + buildStyleCss(data) + '</style>' : '<link rel="stylesheet" href="style.css">';
      return '<!doctype html>\n<html lang="en">\n<head>\n<meta charset="utf-8">\n<meta name="viewport" content="width=device-width, initial-scale=1">\n<title>' + safeText(data.Title) + '</title>\n' + styleTag + '\n</head>\n<body>\n<div class="app"><header class="hero"><p class="eyebrow">' + safeText(data.Style) + '</p><h1>' + safeText(data.Title) + '</h1><p class="promise">' + safeText(data.Promise) + '</p><div class="toolbar"><button class="primary" type="button" data-print>Print Journal</button><button type="button" data-reset>Reset Entries</button><button type="button" data-dark>Dark Mode</button><span class="saved" data-saved>Saved</span></div></header><section class="dashboard"><div class="stat"><strong data-completed>0%</strong><span>Completed</span></div><div class="stat"><strong data-days>' + data.DailyPages + '</strong><span>Daily Pages</span></div><div class="stat"><strong data-entries>0</strong><span>Entries Saved</span></div><div class="stat"><strong data-checks>0</strong><span>Boxes Checked</span></div></section><nav class="tabs" data-tabs><button class="tab active" type="button" data-go="welcome">Welcome</button>' + tabs + '<button class="tab" type="button" data-go="final">Final Review</button></nav><main><section class="journal-page active" data-page="welcome"><div class="page-heading"><p class="eyebrow">Welcome</p><h2>Start Here</h2><p>' + safeText(data.Welcome) + '</p></div><div class="journal-field"><label>My intention for this journal</label><textarea data-save="welcome-intention" placeholder="Write what you want this journal to help you with..."></textarea></div><div class="journal-field"><label>What I want to feel more prepared for</label><textarea data-save="welcome-prepared" placeholder="Write your answer here..."></textarea></div><div class="check-card"><h3>Quick start checklist</h3><label><input data-save="welcome-check-1" type="checkbox"> I understand how to use this journal</label><label><input data-save="welcome-check-2" type="checkbox"> I am ready to write honestly</label><label><input data-save="welcome-check-3" type="checkbox"> I will come back daily</label></div></section>' + buildDailyPages(data) + buildPrayerPage(data) + '<section class="journal-page" data-page="final"><div class="page-heading"><p class="eyebrow">Final Review</p><h2>Reflection and Next Steps</h2><p>Use this page to review your growth, celebrate progress, and decide what you will carry forward.</p></div><div class="journal-field"><label>What changed while using this journal?</label><textarea data-save="final-changed" placeholder="Write your reflection here..."></textarea></div><div class="journal-field"><label>What am I thankful for?</label><textarea data-save="final-thankful" placeholder="Write your gratitude here..."></textarea></div><div class="journal-field"><label>What is my next step?</label><textarea data-save="final-next-step" placeholder="Write your next step here..."></textarea></div></section></main><p class="footer-note">Created with Try Jen Interactive Journal Builder. Your entries save on this device only.</p></div>\n' + scriptTag + '\n</body>\n</html>';
    }

    function generateJournal(){
      var data = getData();
      var html = buildIndexHtml(data, 'download');
      output.value = html;
      renderPreview();
      setStatus('Interactive journal generated');
    }

    function renderPreview(){
      var data = getData();
      previewFrame.srcdoc = buildIndexHtml(data, 'preview');
    }

    function copyHtml(){
      var html = clean(output.value);
      if(!html){ setStatus('Generate the journal first'); return; }
      if(navigator.clipboard){ navigator.clipboard.writeText(html).then(function(){ setStatus('HTML copied'); }).catch(function(){ output.focus(); output.select(); document.execCommand('copy'); setStatus('HTML copied'); }); }
      else { output.focus(); output.select(); document.execCommand('copy'); setStatus('HTML copied'); }
    }

    function downloadFile(filename,content,type){
      var blob = new Blob([content],{type:type || 'text/plain'});
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(function(){ URL.revokeObjectURL(url); },500);
    }

    function downloadHtml(){
      var data = getData();
      var html = buildIndexHtml(data, 'preview');
      downloadFile(slugify(data.Title) + '.html',html,'text/html');
      setStatus('Single HTML downloaded');
    }

    function loadZipLibrary(callback){
      if(window.JSZip){ callback(); return; }
      var existing = document.querySelector('script[data-jszip-loader]');
      if(existing){ existing.addEventListener('load',callback); return; }
      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
      script.async = true;
      script.setAttribute('data-jszip-loader','yes');
      script.onload = callback;
      script.onerror = function(){ downloadHtml(); setStatus('ZIP library blocked, HTML downloaded instead'); };
      document.head.appendChild(script);
    }

    function downloadZip(){
      loadZipLibrary(function(){
        var data = getData();
        var journalKey = slugify(data.Title) + '-' + variationId.toLowerCase();
        var folderName = slugify(data.Title);
        var zip = new JSZip();
        var instructions = [data.Title,'','Thank you for downloading this interactive digital journal.','','How to use:','1. Open the index.html file in your browser.','2. Type directly into the journal pages.','3. Your entries will autosave on your device.','4. Use the Print Journal button if you want to print your pages.','','Important:','Your entries save inside your browser on your own device. If you clear your browser storage, your entries may be removed.','','Seller note:','Customize this product before selling. Change the title, colors, prompts, listing images, and examples so your version feels unique.'].join('\n');
        zip.folder(folderName).file('index.html', buildIndexHtml(data, 'download'));
        zip.folder(folderName).file('style.css', buildStyleCss(data));
        zip.folder(folderName).file('app.js', buildAppJs(journalKey));
        zip.folder(folderName).file('READ-ME.txt', instructions);
        zip.generateAsync({type:'blob'}).then(function(blob){
          var url = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.download = folderName + '.zip';
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(function(){ URL.revokeObjectURL(url); },500);
          setStatus('ZIP downloaded');
        });
      });
    }

    function newVariation(){ variationId = makeVariationId(); generateJournal(); setStatus('New variation created'); }

    q('[data-tj-generate]').addEventListener('click', generateJournal);
    q('[data-tj-copy]').addEventListener('click', copyHtml);
    q('[data-tj-download-html]').addEventListener('click', downloadHtml);
    q('[data-tj-download-zip]').addEventListener('click', downloadZip);
    q('[data-tj-preview]').addEventListener('click', renderPreview);
    q('[data-tj-new]').addEventListener('click', newVariation);
    generateJournal();
  }

  function initAll(){
    var roots = document.querySelectorAll('.tj-journal-builder');
    for(var i = 0; i < roots.length; i++){
      initRoot(roots[i]);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event){
    if(event && event.target){
      var roots = event.target.querySelectorAll('.tj-journal-builder');
      for(var i = 0; i < roots.length; i++){
        initRoot(roots[i]);
      }
    } else {
      initAll();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
